var _metadata, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApexNewWebBookRegular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by FontForge 20201107 at Tue Jan 14 01:23:03 2014\n By Unknown\nCopyright (c) Village Type &#38; Design LLC. All rights reserved.\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "ApexNew-Book",
    horizAdvX: 1167
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Apex New Book",
    fontWeight: 500,
    fontStretch: "normal",
    unitsPerEm: 2048,
    panose1: "2 1 6 0 4 5 1 1 1 3",
    ascent: 1536,
    descent: -512,
    xHeight: 1024,
    capHeight: 1536,
    bbox: "-143 -532 2095 1886",
    underlineThickness: 51,
    underlinePosition: -206,
    unicodeRange: "U+000D-FB04"
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 748,
    d: "M68 0v1365h544v-1365h-544zM136 68h408v1229h-408v-1229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFB01",
    unicode: "fi",
    horizAdvX: 1239,
    d: "M41 911v64l205 59v164q0 177 138 267.5t394 90.5q136 0 273 -18v-135q-170 27 -273 27q-84 0 -153 -12t-124.5 -38.5t-86.5 -72.5t-31 -109v-174h668v-836q0 -53 19 -72.5t67 -19.5v-116q-114 0 -170 52.5t-56 172.5v706h-528v-911h-137v911h-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFB02",
    unicode: "fl",
    horizAdvX: 1239,
    d: "M41 911v64l205 59v164q0 177 138 267.5t394 90.5q136 0 273 -18v-1350q0 -53 19 -72.5t67 -19.5v-116q-114 0 -170 52.5t-56 172.5v1216q-92 9 -133 9q-84 0 -153 -12t-124.5 -38.5t-86.5 -72.5t-31 -109v-174h324v-113h-324v-911h-137v911h-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFB03",
    unicode: "ffi",
    horizAdvX: 1904,
    d: "M41 911v64l205 59v215q0 307 368 307q87 0 144 -14v-129q-70 17 -144 17q-231 0 -231 -181v-225h528v174q0 176 138 267t395 91q135 0 272 -18v-135q-170 27 -272 27q-84 0 -153 -12t-124.5 -38.5t-86.5 -72.5t-31 -109v-174h667v-836q0 -53 19 -72.5t67 -19.5v-116 q-114 0 -169.5 52.5t-55.5 172.5v706h-528v-911h-138v911h-528v-911h-137v911h-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uniFB04",
    unicode: "ffl",
    horizAdvX: 1904,
    d: "M41 911v64l205 59v215q0 307 368 307q87 0 144 -14v-129q-70 17 -144 17q-231 0 -231 -181v-225h528v174q0 176 138 267t395 91q135 0 272 -18v-1350q0 -53 19 -72.5t67 -19.5v-116q-114 0 -169.5 52.5t-55.5 172.5v1216q-92 9 -133 9q-84 0 -153 -12t-124.5 -38.5 t-86.5 -72.5t-31 -109v-174h323v-113h-323v-911h-138v911h-528v-911h-137v911h-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 748,
    d: "M68 0v1365h544v-1365h-544zM136 68h408v1229h-408v-1229z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "glyph1",
    horizAdvX: 2048
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni000D",
    unicode: "\r",
    horizAdvX: 2048
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    unicode: " ",
    horizAdvX: 348
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclam",
    unicode: "!",
    horizAdvX: 389,
    d: "M92 82q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -72.5t-72.5 -29.5t-73 29.5t-30 72.5zM92 1536h205l-61 -1106h-82z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedbl",
    unicode: "\"",
    horizAdvX: 675,
    d: "M92 1536h205l-64 -512h-77zM379 1536h205l-64 -512h-78z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "numbersign",
    unicode: "#",
    horizAdvX: 1136,
    d: "M41 324l41 135h194l109 362h-197l41 135h195l98 324h142l-99 -324h301l99 324h141l-98 -324h196l-41 -135h-194l-109 -362h197l-41 -135h-197l-96 -324h-141l96 324h-301l-96 -324h-142l97 324h-195zM418 459h301l108 362h-301z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dollar",
    unicode: "$",
    horizAdvX: 1054,
    d: "M104 864q0 148 119.5 227.5t354.5 79.5l79 236h154l-94 -246q120 -18 182 -43v-121q-148 50 -354 50q-159 0 -233 -43.5t-74 -139.5q0 -75 65.5 -105t228.5 -44q230 -19 324 -82t94 -209t-123 -232t-366 -86l-80 -233h-154l95 246q-145 18 -201 45v121 q50 -21 153.5 -37.5t208.5 -16.5q165 0 247.5 49.5t82.5 141.5q0 86 -65.5 124t-225.5 50q-230 20 -324 80t-94 188z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "percent",
    unicode: "%",
    horizAdvX: 1931,
    d: "M102 922q0 378 351 378q350 0 350 -378q0 -379 -350 -379q-351 0 -351 379zM233 922q0 -136 51.5 -196t168.5 -60t168 59.5t51 196.5t-51 196.5t-168 59.5t-168.5 -60t-51.5 -196zM434 0l905 1280h158l-905 -1280h-158zM1128 358q0 379 351 379q350 0 350 -379 q0 -378 -350 -378q-351 0 -351 378zM1260 358q0 -137 51 -196.5t168 -59.5t168 59.5t51 196.5t-51 196.5t-168 59.5t-168 -59.5t-51 -196.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ampersand",
    unicode: "&",
    horizAdvX: 1443,
    d: "M92 406q0 94 22 167t65 123.5t88 82.5t110 65q-88 181 -88 368q0 66 19 124.5t58.5 109t111 80.5t167.5 30t167 -30t110.5 -80.5t58 -109t18.5 -124.5q0 -36 -7.5 -68.5t-17.5 -59t-31 -53t-38 -45t-48.5 -41t-52.5 -36t-61 -34t-62 -31t-67 -31.5l-53 -25 q52 -80 109 -149q161 -196 358 -326q110 122 171 305t61 406h139q0 -246 -65.5 -446.5t-186.5 -339.5q142 -79 299 -144l-49 -114q-205 82 -344 165q-207 -165 -482 -165q-100 0 -183.5 22.5t-151.5 71t-106 133t-38 199.5zM236 406q0 -67 20 -119.5t52.5 -85t77.5 -53.5 t90 -29t95 -8q204 0 355 112q-202 137 -357 328q-68 82 -129 178q-48 -26 -81 -51t-63 -62t-45 -89.5t-15 -120.5zM430 1212q0 -154 72 -311l55 27q49 22 66.5 30.5t59.5 30t59 34t45.5 36t40.5 44.5t22 49.5t10 59.5q0 44 -10.5 80.5t-34 68.5t-67 50.5t-103.5 18.5 q-115 0 -165 -61.5t-50 -156.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesingle",
    unicode: "'",
    horizAdvX: 389,
    d: "M92 1536h205l-64 -512h-77z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenleft",
    unicode: "(",
    horizAdvX: 573,
    d: "M102 625q0 184 24.5 357.5t65 304.5t82 226t84.5 158h154q-43 -64 -85 -158.5t-82.5 -225.5t-65.5 -304.5t-25 -357.5t25 -358t65.5 -305t82.5 -225.5t85 -158.5h-154q-43 63 -84.5 158t-82 226t-65 305t-24.5 358z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "parenright",
    unicode: ")",
    horizAdvX: 573,
    d: "M61 -422q43 64 85 158.5t82.5 225.5t65.5 305t25 358t-25 357.5t-65.5 304.5t-82.5 225.5t-85 158.5h154q43 -63 84.5 -158t82 -226t65 -304.5t24.5 -357.5t-24.5 -358t-65 -305t-82 -226t-84.5 -158h-154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asterisk",
    unicode: "*",
    horizAdvX: 727,
    d: "M-12 1204l49 150l262 -123l-23 -76zM86 913l199 213l65 -45l-139 -262zM285 1536h159l-41 -289h-77zM379 1081l65 45l203 -215l-129 -88zM430 1231l264 125l45 -152l-286 -49z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plus",
    unicode: "+",
    horizAdvX: 1003,
    d: "M92 631v135h342v342h135v-342h342v-135h-342v-342h-135v342h-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "comma",
    unicode: ",",
    horizAdvX: 389,
    d: "M51 -256l51 391h185l-133 -391h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "hyphen",
    unicode: "-",
    horizAdvX: 634,
    d: "M61 557v135h512v-135h-512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "period",
    unicode: ".",
    horizAdvX: 389,
    d: "M92 82q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -72.5t-72.5 -29.5t-73 29.5t-30 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "slash",
    unicode: "/",
    horizAdvX: 798,
    d: "M-31 -422l711 2093h149l-710 -2093h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "zero",
    unicode: 0,
    horizAdvX: 1175,
    d: "M113 641q0 133 13.5 232t46 182.5t86.5 135.5t136 80.5t193 28.5t193 -28.5t136 -80.5t86.5 -135.5t46 -182.5t13.5 -232q0 -167 -22 -283.5t-74.5 -204.5t-146.5 -130.5t-232 -42.5t-232 42.5t-146.5 130.5t-74.5 204.5t-22 283.5zM258 641q0 -108 9 -188.5t31 -148 t59.5 -110t95 -65.5t135.5 -23t135.5 23t95 65.5t59.5 110t31 148t9 188.5q0 134 -14.5 227.5t-51 165t-102 106t-162.5 34.5t-162.5 -34.5t-102 -106t-51 -165t-14.5 -227.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "one",
    unicode: 1,
    horizAdvX: 675,
    d: "M23 1143v55l358 102h61v-1300h-143v1153z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "two",
    unicode: 2,
    horizAdvX: 1013,
    d: "M61 0v98q158 121 276.5 221.5t194.5 179.5t124 140.5t71.5 117t31 95t7.5 88.5q0 119 -69 176.5t-232 57.5q-149 0 -324 -62v131q57 23 154 40t172 17q107 0 187 -21t127.5 -54t76.5 -82t39 -97.5t10 -107.5q0 -92 -21.5 -160.5t-93.5 -161.5t-194.5 -203.5 t-339.5 -285.5h674v-127h-871z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "three",
    unicode: 3,
    horizAdvX: 1034,
    d: "M102 -84q173 -66 338 -66q363 0 363 326q0 157 -81.5 227t-268.5 70h-228v135h228q83 0 143.5 24.5t93 66.5t47.5 88.5t15 99.5q0 62 -13.5 109.5t-47.5 90t-101 65t-164 22.5q-149 0 -324 -62v131q57 23 153.5 40t170.5 17q130 0 225 -32.5t148.5 -91t78.5 -130 t25 -159.5q0 -104 -56.5 -199.5t-152.5 -136.5q126 -34 193 -139t67 -236q0 -75 -16.5 -139.5t-54.5 -123t-96 -100t-146.5 -65.5t-200.5 -24q-204 0 -338 65v127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "four",
    unicode: 4,
    d: "M82 193v86l700 1021h105v-981h219v-126h-219v-449h-139v449h-666zM244 315l504 4l4 740z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "five",
    unicode: 5,
    horizAdvX: 1024,
    d: "M78 -84q173 -66 340 -66q59 0 110 7.5t110 31t100 62.5t68.5 108.5t27.5 161.5q0 64 -13 113.5t-30.5 81.5t-52.5 54.5t-62 33.5t-77 16.5t-78.5 6.5t-85.5 1h-3.5h-3.5h-287v752h809v-127h-669v-502q116 11 194 11q59 0 106.5 -4t101.5 -15.5t95.5 -31t81 -53t65 -79 t41 -111t15.5 -147.5q0 -92 -19.5 -166.5t-51.5 -125.5t-78.5 -89t-94.5 -59.5t-107.5 -35t-108.5 -17.5t-105 -4q-204 0 -338 65v127z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "six",
    unicode: 6,
    horizAdvX: 1177,
    d: "M113 707q0 159 15 282.5t53.5 233t101.5 180.5t161.5 112t231.5 41q237 0 358 -69v-135q-142 73 -358 73q-432 0 -432 -659q20 37 50 70.5t74.5 64t107.5 48.5t136 18q87 0 157.5 -17t118 -44.5t83 -68.5t55 -82t31 -94t15 -95t3.5 -93q0 -49 -4.5 -93t-17.5 -95 t-34.5 -93.5t-57 -82.5t-83 -67.5t-115.5 -44.5t-151 -17q-73 0 -133 11t-107.5 30.5t-84.5 50.5t-64 67t-46.5 85.5t-32 100t-19.5 115.5t-9.5 127t-2.5 140zM264 473q0 -367 348 -367q80 0 140 25.5t93.5 63t54 90t26.5 96.5t6 92q0 35 -2 64.5t-10 68.5t-21 70t-37.5 63 t-57 53t-82 34.5t-110.5 13.5q-83 0 -146.5 -23.5t-101 -59.5t-61 -86.5t-31.5 -97.5t-8 -100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "seven",
    unicode: 7,
    horizAdvX: 890,
    d: "M20 1153v127h850v-98l-577 -1438h-158l598 1409h-713z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eight",
    unicode: 8,
    d: "M66 432q0 126 64.5 233.5t188.5 143.5q-97 45 -149.5 131.5t-52.5 189.5q0 88 25 161.5t77.5 134.5t145.5 95.5t219 34.5t219 -34.5t145.5 -95.5t77.5 -134.5t25 -161.5q0 -103 -53 -189.5t-150 -131.5q124 -36 189 -143.5t65 -233.5q0 -74 -17 -139t-55.5 -123.5 t-97.5 -100t-147.5 -65.5t-200.5 -24t-200.5 24t-147.5 65.5t-97.5 100t-55.5 123.5t-17 139zM217 432q0 -47 10 -90.5t36 -87.5t66.5 -76t106 -52t148.5 -20t148.5 20t105.5 52t66 76t36 87.5t10 90.5q0 301 -366 301q-367 0 -367 -301zM268 1130q0 -52 17.5 -98 t53.5 -85.5t99 -63t146 -23.5t146 23.5t98.5 63t53 85.5t17.5 98q0 44 -7.5 83.5t-29 80.5t-55 70t-91 47.5t-132.5 18.5t-132.5 -18.5t-91.5 -48t-55.5 -70t-29 -80t-7.5 -83.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nine",
    unicode: 9,
    horizAdvX: 1177,
    d: "M113 807q0 49 4.5 93t17.5 95t34 93.5t57 82.5t83 67.5t115 44.5t151 17q93 0 166 -18t125.5 -49t90 -82.5t60.5 -108t36 -135.5t17.5 -156t4.5 -178q0 -159 -15 -282.5t-53.5 -233t-101.5 -180.5t-161.5 -112t-231.5 -41q-237 0 -358 69v135q142 -73 358 -73 q432 0 432 659q-44 -82 -136.5 -141.5t-232.5 -59.5q-87 0 -157.5 17t-118 44.5t-82.5 68.5t-54.5 82t-31 94t-15 95t-3.5 93zM256 807q0 -42 3.5 -76.5t13.5 -80t32 -80t55.5 -65.5t88.5 -48t126 -17q83 0 147 23.5t101 59.5t61 86.5t32 97.5t8 100q0 55 -7.5 102 t-30.5 97.5t-60.5 86t-101.5 58.5t-149 23q-80 0 -140 -25.5t-93 -63t-53.5 -90t-26.5 -96.5t-6 -92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "colon",
    unicode: ":",
    horizAdvX: 389,
    d: "M92 82q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -72.5t-72.5 -29.5t-73 29.5t-30 72.5zM92 768q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -72.5t-72.5 -29.5t-73 29.5t-30 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "semicolon",
    unicode: ";",
    horizAdvX: 389,
    d: "M51 -256l51 391h185l-133 -391h-103zM92 768q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -72.5t-72.5 -29.5t-73 29.5t-30 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "less",
    unicode: "<",
    horizAdvX: 1003,
    d: "M92 631v135l819 477v-149l-678 -396l678 -395v-149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "equal",
    unicode: "=",
    horizAdvX: 1003,
    d: "M92 496v135h819v-135h-819zM92 766v135h819v-135h-819z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "greater",
    unicode: ">",
    horizAdvX: 1003,
    d: "M92 154v149l678 395l-678 396v149l819 -477v-135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "question",
    unicode: "?",
    horizAdvX: 962,
    d: "M51 1382v123q49 20 145.5 35.5t170.5 15.5q125 0 217 -22.5t146 -59t86.5 -91.5t43 -109t10.5 -123q0 -76 -18.5 -135t-47 -99t-81.5 -77t-101 -60t-128 -55q-37 -15 -63.5 -31.5t-43 -39t-26 -41.5t-13.5 -53.5t-5 -58.5t-1 -71h-76q-10 48 -14 82t-3.5 76t13 74.5 t36 66t66 61.5t101.5 50q114 43 157 73q108 73 111 225v11q0 55 -8.5 95t-32.5 77t-64 59.5t-105 36t-154 13.5q-187 0 -318 -48zM242 82q0 43 29.5 72.5t72.5 29.5t72.5 -29.5t29.5 -72.5t-29.5 -72.5t-72.5 -29.5t-72.5 29.5t-29.5 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "at",
    unicode: "@",
    horizAdvX: 1781,
    d: "M82 512q0 788 819 788q394 0 596.5 -168.5t202.5 -500.5q0 -49 -4.5 -95.5t-17.5 -100.5t-33.5 -100t-56 -90t-82 -75t-114 -49.5t-149.5 -18.5h-80l-30 76q-128 -96 -279 -96q-79 0 -146 26.5t-120 77.5t-83 135t-30 191t30 191t83 135t120 77.5t146 26.5q151 0 279 -96 l30 76h80v-703q177 -1 251.5 103.5t74.5 318.5q0 288 -160 413.5t-508 125.5t-513 -157.5t-165 -510.5t165 -510.5t513 -157.5q141 0 283.5 23t238.5 63l2 -127q-100 -36 -240.5 -57.5t-283.5 -21.5q-819 0 -819 788zM618 512q0 -154 61.5 -228.5t194.5 -74.5q105 0 226 65 v476q-121 65 -226 65q-133 0 -194.5 -74.5t-61.5 -228.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "A",
    unicode: "A",
    horizAdvX: 1290,
    d: "M51 0l543 1556h102l543 -1556h-158l-141 430h-590l-141 -430h-158zM389 551h510l-254 772z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "B",
    unicode: "B",
    horizAdvX: 1259,
    d: "M154 0v1536h485q130 0 225 -31.5t148.5 -88.5t78.5 -128t25 -158q0 -104 -52 -191t-149 -128q84 -23 142.5 -83t84 -135t25.5 -161q0 -94 -27 -169.5t-85.5 -136t-160.5 -93.5t-241 -33h-499zM293 129h379q84 0 146.5 18t99.5 46t60 69t30.5 81.5t7.5 88.5 q0 159 -77.5 231t-262.5 72h-383v-606zM293 864h383q83 0 142 22.5t89.5 62t44 84t13.5 97.5q0 57 -12 101.5t-43 86.5t-94.5 65.5t-156.5 23.5h-366v-543z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "C",
    unicode: "C",
    horizAdvX: 1249,
    d: "M123 768q0 136 18.5 250t62.5 215.5t112 171.5t172.5 110.5t238.5 40.5q238 0 399 -71v-137q-107 43 -196 61t-203 18q-98 0 -176 -33t-130 -91.5t-86.5 -142.5t-49.5 -181t-15 -211t15 -211t49.5 -181t86.5 -142.5t130 -91.5t176 -33q114 0 203 18t196 61v-137 q-161 -71 -399 -71q-134 0 -238.5 40.5t-172.5 110.5t-112 171.5t-62.5 215.5t-18.5 250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "D",
    unicode: "D",
    horizAdvX: 1341,
    d: "M154 0v1536h417q147 0 260 -38.5t185.5 -105.5t118.5 -166t65 -210t19 -248t-19 -248t-65 -210t-118.5 -166t-185.5 -105.5t-260 -38.5h-417zM293 129h287q491 0 491 639t-491 639h-287v-1278z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "E",
    unicode: "E",
    d: "M154 0v1536h890v-129h-751v-543h680v-129h-680v-606h751v-129h-890z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "F",
    unicode: "F",
    horizAdvX: 1126,
    d: "M154 0v1536h870v-129h-731v-543h659v-129h-659v-735h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "G",
    unicode: "G",
    horizAdvX: 1351,
    d: "M123 768q0 136 18.5 250t62.5 215.5t112 171.5t172.5 110.5t238.5 40.5q262 0 430 -86v-139q-128 53 -219.5 74.5t-210.5 21.5q-98 0 -176 -33t-130 -91.5t-86.5 -142.5t-49.5 -181t-15 -211t15 -211t49.5 -181t86.5 -142.5t130 -91.5t176 -33q239 0 332 45v524h-322v129 h461v-744q-176 -83 -471 -83q-134 0 -238.5 40.5t-172.5 110.5t-112 171.5t-62.5 215.5t-18.5 250z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "H",
    unicode: "H",
    horizAdvX: 1351,
    d: "M154 0v1536h139v-672h766v672h139v-1536h-139v735h-766v-735h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "I",
    unicode: "I",
    horizAdvX: 532,
    d: "M195 0v1536h143v-1536h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "J",
    unicode: "J",
    horizAdvX: 776,
    d: "M72 -6v131q65 -16 143 -16q107 0 165 39.5t58 134.5v1253h144v-1249q0 -307 -367 -307q-86 0 -143 14z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "K",
    unicode: "K",
    horizAdvX: 1218,
    d: "M154 0v1536h139v-766l641 766h180l-598 -688l660 -848h-183l-567 743l-133 -153v-590h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "L",
    unicode: "L",
    horizAdvX: 1085,
    d: "M154 0v1536h139v-1407h711v-129h-850z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "M",
    unicode: "M",
    horizAdvX: 1720,
    d: "M154 0v1536h188l518 -1130l518 1130h189v-1536h-140l9 1354l-518 -1118h-115l-518 1118l8 -1354h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "N",
    unicode: "N",
    horizAdvX: 1372,
    d: "M154 0v1536h104l825 -1251l-4 1251h140v-1536h-105l-825 1251l4 -1251h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "O",
    unicode: "O",
    horizAdvX: 1392,
    d: "M123 768q0 94 5 170.5t20.5 160.5t41.5 148t70 124.5t103 99.5t143.5 62t189.5 23t189.5 -23t144 -62.5t103 -99t69.5 -124t41.5 -148.5t21 -160.5t5.5 -170.5t-5.5 -170.5t-21 -160.5t-41.5 -148.5t-69.5 -124t-103 -99t-144 -62.5t-189.5 -23t-189.5 23t-143.5 62 t-103 99.5t-70 124.5t-41.5 148t-20.5 160.5t-5 170.5zM270 768q0 -86 4 -153.5t15.5 -138t31 -123t52 -100.5t76.5 -78.5t106.5 -48t140.5 -17.5t140.5 17.5t106.5 48t76.5 78.5t52 100.5t31 123t15.5 138t4 153.5t-4 153.5t-15.5 138t-31 123t-52 100.5t-76.5 78.5 t-106.5 48t-140.5 17.5t-140.5 -17.5t-106.5 -48t-76.5 -78.5t-52 -100.5t-31 -123t-15.5 -138t-4 -153.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "P",
    unicode: "P",
    horizAdvX: 1208,
    d: "M154 0v1536h469q112 0 200.5 -25t146.5 -68t96 -102.5t54.5 -125t16.5 -140.5t-16.5 -140.5t-54.5 -125t-96 -102.5t-146.5 -68t-200.5 -25h-330v-614h-139zM293 743h348q83 0 146.5 21t100 53t59.5 78t30.5 88.5t7.5 91.5t-7.5 91.5t-30.5 88.5t-59.5 78t-100 53 t-146.5 21h-348v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Q",
    unicode: "Q",
    horizAdvX: 1392,
    d: "M123 768q0 101 6 182t22 165t42.5 147.5t70.5 120.5t103 94t142.5 58t186.5 21q105 0 188.5 -21.5t143 -57.5t103.5 -93.5t70 -121t42 -147.5t21.5 -165t5.5 -182q0 -89 -3.5 -158.5t-14 -145t-28.5 -132t-48.5 -111.5t-72.5 -94t-102 -68.5t-135 -44.5v-2l588 -118v-148 l-946 254q-82 22 -145 62.5t-104.5 98.5t-69 123t-41.5 148.5t-19.5 161t-5.5 174.5zM270 768q0 -86 4 -153.5t15.5 -138t31 -123t52 -100.5t76.5 -78.5t106.5 -48t140.5 -17.5t140.5 17.5t106.5 48t76.5 78.5t52 100.5t31 123t15.5 138t4 153.5t-4 153.5t-15.5 138t-31 123 t-52 100.5t-76.5 78.5t-106.5 48t-140.5 17.5t-140.5 -17.5t-106.5 -48t-76.5 -78.5t-52 -100.5t-31 -123t-15.5 -138t-4 -153.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "R",
    unicode: "R",
    horizAdvX: 1271,
    d: "M154 0v1536h481q141 0 239.5 -29.5t155.5 -88t82 -135t25 -179.5q0 -107 -26 -185.5t-90 -137t-167 -85.5l367 -696h-162l-344 674q-23 -2 -68 -2h-354v-672h-139zM293 801h379q79 0 136.5 16.5t91 42.5t53.5 67t26 82t6 95t-6 95t-26 82t-53.5 67t-91 42.5t-136.5 16.5 h-379v-606z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "S",
    unicode: "S",
    horizAdvX: 1218,
    d: "M111 61v134q7 -2 49.5 -17t60 -20.5t61.5 -17.5t77.5 -17t83 -9.5t100.5 -4.5q415 0 415 333q0 66 -12 111.5t-35 77t-67.5 52t-96.5 32t-135 22.5q-141 18 -232 43.5t-153.5 70.5t-89 111.5t-26.5 165.5q0 59 12 113.5t46.5 113.5t89.5 102t150 71t218 28q246 0 399 -71 v-137q-103 44 -194 61.5t-207 17.5q-109 0 -185 -23.5t-115.5 -67t-56 -94t-16.5 -116.5q0 -41 5 -73t19 -57t28 -43t42.5 -32.5t50.5 -23t65 -17t73 -13t86 -11.5q98 -13 167 -29.5t133.5 -46.5t103 -73.5t61 -109.5t22.5 -155q0 -68 -14.5 -129t-54 -123.5t-101 -107.5 t-163.5 -73.5t-234 -28.5q-104 0 -230.5 24t-199.5 57z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "T",
    unicode: "T",
    horizAdvX: 1146,
    d: "M80 1407v129h987v-129h-424v-1407h-139v1407h-424z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "U",
    unicode: "U",
    horizAdvX: 1372,
    d: "M143 481v1055h140v-1032q0 -395 403 -395q404 0 404 395v1032h139v-1055q0 -90 -21 -164.5t-54.5 -125.5t-80.5 -90t-95.5 -61.5t-104 -36.5t-99.5 -18.5t-88 -4.5t-88 4.5t-99.5 18.5t-104 36.5t-95.5 61.5t-80.5 90t-54.5 125.5t-21 164.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "V",
    unicode: "V",
    horizAdvX: 1310,
    d: "M61 1536h158l436 -1323l437 1323h157l-542 -1556h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "W",
    unicode: "W",
    horizAdvX: 1802,
    d: "M61 1536h148l268 -1339l346 1339h156l346 -1339l268 1339h148l-336 -1556h-150l-354 1372l-354 -1372h-150z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "X",
    unicode: "X",
    horizAdvX: 1290,
    d: "M20 0l502 778l-491 758h174l409 -668l410 668h174l-491 -758l501 -778h-180l-414 684l-413 -684h-181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Y",
    unicode: "Y",
    horizAdvX: 1372,
    d: "M61 1536h154l471 -788l471 788h154l-555 -901v-635h-140v635z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Z",
    unicode: "Z",
    horizAdvX: 1249,
    d: "M82 0v94l874 1317l-833 -4v129h1014v-94l-875 -1317l905 4v-129h-1085z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketleft",
    unicode: "[",
    horizAdvX: 471,
    d: "M133 -422v2093h277v-135h-131v-1823h131v-135h-277z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "backslash",
    unicode: "\\\\\\\\",
    horizAdvX: 798,
    d: "M-31 1671h150l710 -2093h-149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bracketright",
    unicode: "]",
    horizAdvX: 471,
    d: "M61 -287h132v1823h-132v135h277v-2093h-277v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciicircum",
    unicode: "^",
    horizAdvX: 1146,
    d: "M29 768l477 788h135l477 -788h-149l-396 637l-395 -637h-149z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "underscore",
    unicode: "_",
    horizAdvX: 573,
    d: "M0 -195h573v-122h-573v122z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "grave",
    unicode: "`",
    d: "M369 1536h163l103 -410h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "a",
    unicode: "a",
    horizAdvX: 1013,
    d: "M102 309q0 298 365 320l270 16v57q0 116 -52.5 166t-190.5 50q-154 0 -308 -52v123q127 55 308 55q112 0 189.5 -24t119.5 -71.5t60 -107.5t18 -141v-700h-80l-31 82q-138 -102 -309 -102q-97 0 -168.5 26.5t-112 74t-59.5 104t-19 124.5zM248 309q0 -32 3.5 -57t17 -54 t36 -47.5t63.5 -31.5t97 -13q78 0 138.5 20t133.5 62v357l-280 -27q-209 -20 -209 -209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "b",
    unicode: "b",
    horizAdvX: 1095,
    d: "M133 0v1536h143v-575q128 83 287 83q96 0 170 -27.5t120.5 -74.5t76 -116t41.5 -145t12 -169t-12 -169t-41.5 -145t-76 -116t-120.5 -74.5t-170 -27.5q-157 0 -319 104l-31 -84h-80zM276 172q64 -34 128 -50t159 -16q71 0 123 23.5t81 60t46 93t22 108.5t5 121t-5 121 t-22 108.5t-46 93t-81 60t-123 23.5q-95 0 -159 -16t-128 -50v-680z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "c",
    unicode: "c",
    horizAdvX: 942,
    d: "M113 512q0 94 11.5 169.5t41 145t77.5 116t124.5 74t177.5 27.5q187 0 305 -51v-123q-142 48 -307 48q-63 0 -111 -15.5t-78.5 -45.5t-50.5 -65.5t-30 -85t-13.5 -93.5t-3.5 -101t3.5 -101t13.5 -93.5t30 -85t50.5 -65.5t78.5 -45.5t111 -15.5q165 0 307 48v-123 q-118 -51 -305 -51q-101 0 -177.5 27.5t-124.5 74t-77.5 116t-41 145t-11.5 169.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "d",
    unicode: "d",
    horizAdvX: 1095,
    d: "M113 512q0 93 11.5 169t41 145t76 116t120.5 74.5t170 27.5q159 0 287 -83v575h144v-1536h-80l-31 84q-162 -104 -320 -104q-96 0 -170 27.5t-120.5 74.5t-76 116t-41 145t-11.5 169zM256 512q0 -48 2.5 -86.5t9.5 -82t19 -76.5t33 -64.5t49.5 -52t70 -32.5t92.5 -12 q95 0 159 16t128 50v680q-64 34 -128 50t-159 16q-51 0 -92.5 -12t-70 -32.5t-49.5 -52t-33 -64.5t-19 -76.5t-9.5 -82t-2.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "e",
    unicode: "e",
    horizAdvX: 1044,
    d: "M113 512q0 94 11.5 169.5t40.5 145t76.5 116t124 74t177.5 27.5q85 0 149.5 -18t106.5 -55t69 -81.5t40.5 -109.5t18.5 -125.5t5 -142.5v-66h-676q3 -58 11 -104t27.5 -92t50 -76t81 -49t117.5 -19q111 0 187 13t151 45v-123q-138 -61 -338 -61q-101 0 -177.5 27.5 t-124 74t-76.5 116t-40.5 145t-11.5 169.5zM256 563h532q0 47 -1 77.5t-6.5 72t-15 67.5t-27.5 55t-43.5 45t-64 27t-87.5 11q-69 0 -120.5 -20t-82 -51.5t-49.5 -80t-26 -95.5t-9 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "f",
    unicode: "f",
    horizAdvX: 768,
    d: "M41 911v64l205 59v215q0 307 368 307q87 0 144 -14v-129q-70 17 -144 17q-231 0 -231 -181v-225h324v-113h-324v-911h-137v911h-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "g",
    unicode: "g",
    horizAdvX: 1044,
    d: "M37 -223q0 99 59 169t152 101v2q-66 46 -66 135q0 77 78 140q-164 91 -164 335q0 385 400 385q85 0 163 -20h349v-78l-172 -49q59 -91 59 -238q0 -385 -399 -385q-73 0 -136 13q-38 -38 -38 -76t18.5 -56.5t58.5 -23.5l349 -41q147 -15 213.5 -78.5t66.5 -195.5 q0 -91 -42.5 -159.5t-118 -109t-168.5 -60t-203 -19.5q-225 0 -342 73t-117 236zM170 -215q0 -109 79.5 -152t246.5 -43q82 0 149.5 11.5t125 36t90 70t32.5 108.5q0 77 -39.5 112.5t-134.5 46.5l-299 35q-250 -57 -250 -225zM229 659q0 -46 4.5 -79.5t20.5 -69.5t44 -59 t78 -37.5t120 -14.5q50 0 90 7.5t67.5 20t47.5 32.5t31.5 40.5t18.5 49t9 53.5t2 57q0 46 -4.5 79.5t-20.5 70t-43.5 59t-77.5 37.5t-120 15t-120 -15t-78 -37.5t-44 -59t-20.5 -70t-4.5 -79.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "h",
    unicode: "h",
    horizAdvX: 1024,
    d: "M133 0v1536h139v-575q128 83 281 83q348 0 348 -307v-737h-143v743q0 95 -52 135t-153 40q-95 0 -157.5 -16t-123.5 -50v-852h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "i",
    unicode: "i",
    horizAdvX: 491,
    d: "M133 1331q0 43 30 73t73 30t72.5 -30t29.5 -73t-29.5 -72.5t-72.5 -29.5t-73 29.5t-30 72.5zM166 205v819h139v-836q0 -53 19 -72.5t67 -19.5v-116q-114 0 -169.5 52.5t-55.5 172.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "j",
    unicode: "j",
    horizAdvX: 471,
    d: "M-96 -412q49 7 92.5 22t83.5 41.5t63 70.5t23 100v1202h139v-1221q0 -77 -36 -140.5t-95 -103.5t-128.5 -63.5t-141.5 -27.5v120zM133 1331q0 43 30 73t73 30t72.5 -30t29.5 -73t-29.5 -72.5t-72.5 -29.5t-73 29.5t-30 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "k",
    unicode: "k",
    horizAdvX: 1024,
    d: "M133 0v1536h139v-971l463 459h193l-441 -422l496 -602h-178l-404 520l-129 -123v-397h-139z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "l",
    unicode: "l",
    horizAdvX: 491,
    d: "M166 205v1331h139v-1348q0 -53 19 -72.5t67 -19.5v-116q-114 0 -169.5 52.5t-55.5 172.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "m",
    unicode: "m",
    horizAdvX: 1607,
    d: "M133 0v1024h80l31 -84q142 104 299 104q207 0 286 -116q166 116 318 116q166 0 252 -77t86 -230v-737h-144v743q0 95 -50 135t-144 40q-89 0 -150 -16.5t-129 -51.5q13 -54 13 -107v-743h-144v743q0 95 -50 135t-144 40q-85 0 -144 -14.5t-123 -47.5v-856h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "n",
    unicode: "n",
    horizAdvX: 1024,
    d: "M133 0v1024h80l31 -86q141 106 309 106q348 0 348 -307v-737h-143v743q0 95 -52 135t-153 40q-94 0 -155 -15.5t-122 -50.5v-852h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "o",
    unicode: "o",
    horizAdvX: 1085,
    d: "M113 512q0 100 11 176.5t40 145.5t76.5 113.5t123.5 70.5t179 26t179.5 -26t124 -70.5t76.5 -113.5t39.5 -145.5t10.5 -176.5t-10.5 -176.5t-39.5 -145.5t-76.5 -113.5t-124 -70.5t-179.5 -26t-179 26t-123.5 70.5t-76.5 113.5t-40 145.5t-11 176.5zM256 512 q0 -57 1.5 -95.5t8 -85t18.5 -77t33 -61t51 -48t74 -28.5t101 -11q56 0 99.5 11t73.5 28.5t51 48t33 61t18.5 76.5t8.5 85.5t2 95.5t-2 95.5t-8.5 85.5t-18.5 76.5t-33 61t-51 48t-73.5 28.5t-99.5 11q-57 0 -101 -11t-74 -28.5t-51 -48t-33 -61t-18.5 -77t-8 -85 t-1.5 -95.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "p",
    unicode: "p",
    horizAdvX: 1095,
    d: "M133 -512v1536h80l31 -84q162 104 319 104q96 0 170 -27.5t120.5 -74.5t76 -116t41.5 -145t12 -169t-12 -169t-41.5 -145t-76 -116t-120.5 -74.5t-170 -27.5q-159 0 -287 83v-575h-143zM276 172q64 -34 128 -50t159 -16q71 0 123 23.5t81 60t46 93t22 108.5t5 121t-5 121 t-22 108.5t-46 93t-81 60t-123 23.5q-95 0 -159 -16t-128 -50v-680z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "q",
    unicode: "q",
    horizAdvX: 1095,
    d: "M113 512q0 93 11.5 169t41 145t76 116t120.5 74.5t170 27.5q158 0 320 -104l31 84h80v-1536h-144v575q-128 -83 -287 -83q-96 0 -170 27.5t-120.5 74.5t-76 116t-41 145t-11.5 169zM256 512q0 -48 2.5 -86.5t9.5 -82t19 -76.5t33 -64.5t49.5 -52t70 -32.5t92.5 -12 q95 0 159 16t128 50v680q-64 34 -128 50t-159 16q-51 0 -92.5 -12t-70 -32.5t-49.5 -52t-33 -64.5t-19 -76.5t-9.5 -82t-2.5 -86.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "r",
    unicode: "r",
    horizAdvX: 743,
    d: "M133 0v1024h80l31 -86q141 106 329 106q58 0 123 -10v-133q-53 17 -123 17q-180 0 -297 -66v-852h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "s",
    unicode: "s",
    horizAdvX: 942,
    d: "M106 741q0 58 20 109t62.5 96t119.5 71.5t181 26.5q177 0 295 -51v-123q-142 48 -297 48q-74 0 -123.5 -13t-75.5 -38.5t-36 -55t-10 -70.5q0 -49 16.5 -77t68.5 -48t148 -28q86 -8 149 -25t104 -41t65 -59.5t33.5 -75t9.5 -92.5q0 -63 -21.5 -116.5t-67 -99.5 t-128.5 -72.5t-195 -26.5q-73 0 -164 15.5t-141 35.5v123q131 -48 307 -48q147 0 208.5 52t61.5 135q0 39 -8 65.5t-31 51t-70.5 39t-121.5 20.5q-108 10 -181 33.5t-110.5 60.5t-52.5 79t-15 99z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "t",
    unicode: "t",
    horizAdvX: 768,
    d: "M41 911v64l205 59v277l143 41v-328h318v-113h-318v-637q0 -92 49 -134t148 -42q26 0 80 4v-114q-33 -8 -93 -8q-66 0 -123 15.5t-103.5 47.5t-73.5 87t-27 128v653h-205z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "u",
    unicode: "u",
    horizAdvX: 1024,
    d: "M123 287v737h143v-743q0 -95 52 -135t153 -40q94 0 155 15.5t122 50.5v852h143v-1024h-80l-31 86q-141 -106 -309 -106q-348 0 -348 307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "v",
    unicode: "v",
    horizAdvX: 983,
    d: "M41 1024h158l293 -840l292 840h158l-399 -1044h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "w",
    unicode: "w",
    horizAdvX: 1433,
    d: "M41 1024h154l192 -803l254 803h152l254 -803l192 803h154l-289 -1044h-107l-280 890l-281 -890h-106z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "x",
    unicode: "x",
    horizAdvX: 1003,
    d: "M41 0l379 526l-359 498h170l271 -401l270 401h170l-358 -498l379 -526h-170l-291 430l-291 -430h-170z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "y",
    unicode: "y",
    horizAdvX: 983,
    d: "M41 1024h164l287 -840l286 840h164l-590 -1536h-153l231 539z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "z",
    unicode: "z",
    horizAdvX: 931,
    d: "M72 0v92l600 811h-570v121h748v-92l-600 -811h620v-121h-798z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceleft",
    unicode: "{",
    horizAdvX: 430,
    d: "M37 557v135h20q46 0 67 20t19 60l-37 676q-6 114 56.5 168.5t175.5 54.5h31v-135h-31q-46 0 -67 -20.5t-19 -59.5l37 -676q3 -90 -62 -155q65 -65 62 -156l-37 -676q-2 -39 19 -59.5t67 -20.5h31v-135h-31q-113 0 -175.5 54.5t-56.5 168.5l37 676q3 74 -75 80h-31z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bar",
    unicode: "|",
    horizAdvX: 501,
    d: "M178 -422v2093h146v-2093h-146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "braceright",
    unicode: "}",
    horizAdvX: 430,
    d: "M61 -287h31q46 0 67 20.5t19 59.5l-37 676q-1 45 18.5 89.5t49.5 66.5q-30 22 -49.5 65.5t-18.5 89.5l37 676q2 39 -19 59.5t-67 20.5h-31v135h31q113 0 175.5 -54.5t56.5 -168.5l-37 -676q-2 -40 19 -60t67 -20h20v-135h-31q-78 -6 -75 -80l37 -676q6 -114 -56.5 -168.5 t-175.5 -54.5h-31v135z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "asciitilde",
    unicode: "~",
    horizAdvX: 1003,
    d: "M92 631v133q30 28 86 49t121 21q58 0 105.5 -15.5t80.5 -37.5t64 -44t69 -37.5t82 -15.5q69 0 126.5 26.5t84.5 55.5v-133q-30 -28 -85.5 -49t-120.5 -21q-70 0 -128 23.5t-91.5 51.5t-81.5 51.5t-101 23.5q-69 0 -126.5 -26.5t-84.5 -55.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    unicode: "\xA0",
    horizAdvX: 348
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "exclamdown",
    unicode: "\xA1",
    horizAdvX: 389,
    d: "M92 -512l62 1106h82l61 -1106h-205zM92 942q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -72.5t-72.5 -29.5t-73 29.5t-30 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cent",
    unicode: "\xA2",
    horizAdvX: 1054,
    d: "M113 641q0 165 51.5 282t165 184t282.5 67l80 235h154l-94 -246q108 -13 186 -47v-123q-160 54 -328 54q-94 0 -163.5 -30.5t-110.5 -87t-60.5 -128t-19.5 -160.5t19.5 -161t60.5 -127.5t110.5 -86t163.5 -30.5q177 0 328 51v-123q-127 -55 -326 -55q-45 0 -65 2 l-80 -238h-154l101 262q-301 102 -301 506z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "sterling",
    unicode: "\xA3",
    horizAdvX: 1112,
    d: "M43 0v125h154v477h-154v125h154v199q0 175 105.5 274.5t336.5 99.5q83 0 187 -16t167 -43v-123q-166 56 -354 56q-161 0 -230 -57.5t-69 -188.5v-201h510v-125h-510v-477h694v-125h-991z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "currency",
    unicode: "\xA4",
    horizAdvX: 1310,
    d: "M86 68l150 176q-123 129 -123 395q0 267 120 393l-147 178l104 88l154 -184q119 57 311 57q193 0 310 -57l155 184l105 -88l-150 -178q123 -129 123 -393q0 -262 -123 -395l150 -176l-105 -88l-155 184q-121 -58 -310 -58q-190 0 -309 58l-156 -184zM250 639 q0 -102 20 -175.5t53.5 -117.5t87.5 -70t110.5 -34.5t133.5 -8.5t133.5 8.5t110.5 34.5t87.5 70t54 117.5t20.5 175.5t-20.5 175.5t-54 117.5t-87.5 69.5t-110.5 34t-133.5 8.5q-64 0 -112.5 -6t-97 -21.5t-82 -44.5t-60.5 -73t-40 -109.5t-13 -150.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yen",
    unicode: "\xA5",
    horizAdvX: 1148,
    d: "M41 1280h172l362 -670l361 670h172l-277 -471h216v-125h-289l-92 -156h381v-125h-402v-403h-139v403h-404v125h381l-92 156h-289v125h215z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "brokenbar",
    unicode: "\xA6",
    horizAdvX: 501,
    d: "M178 -422v979h146v-979h-146zM178 692v977h146v-977h-146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "section",
    unicode: "\xA7",
    horizAdvX: 1267,
    d: "M80 559q0 101 44 195t144 155q-65 76 -65 228q0 48 9 93t30 94.5t60.5 89.5t94.5 72.5t138.5 51t187.5 18.5q246 0 399 -71v-137q-103 44 -194 61.5t-207 17.5q-89 0 -155.5 -15t-108 -40.5t-67.5 -64t-36 -79.5t-10 -93q0 -34 6 -62.5t14.5 -50.5t26.5 -40.5t33.5 -32 t45 -26t51 -20t61.5 -17t66 -14.5t75 -14q142 -25 227.5 -52t141 -73t76 -108t20.5 -160q0 -101 -44.5 -195t-144.5 -155q66 -84 66 -228q0 -48 -9 -93t-30 -94.5t-60.5 -89.5t-94.5 -72.5t-138.5 -51t-187.5 -18.5q-247 0 -400 71v137q103 -44 194.5 -61.5t207.5 -17.5 q89 0 155.5 15t108 40.5t67.5 64t36 79.5t10 93q0 34 -6 62.5t-14.5 50.5t-26.5 40.5t-33.5 32t-45 26t-51 20t-61.5 17t-66 14.5t-75 14q-142 25 -227.5 52t-141 73t-76 108t-20.5 160zM219 557q0 -60 15 -101.5t33.5 -66t68 -43.5t85 -27t117.5 -23l9 -1.5t8.5 -1.5 t9.5 -2q230 -43 316 -88q168 70 168 264q0 43 -7 76t-18 57t-33.5 42.5t-44.5 30t-60 22t-70.5 17t-85.5 16.5q-19 3 -28 5q-224 38 -317 88q-166 -70 -166 -264z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "dieresis",
    unicode: "\xA8",
    d: "M287 1331q0 43 29.5 73t72.5 30t73 -30t30 -73t-30 -72.5t-73 -29.5t-72.5 29.5t-29.5 72.5zM676 1331q0 43 29.5 73t72.5 30t73 -30t30 -73t-30 -72.5t-73 -29.5t-72.5 29.5t-29.5 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "copyright",
    unicode: "\xA9",
    horizAdvX: 1585,
    d: "M113 641q0 155 53.5 281t146 208t216 126t264.5 44t264.5 -44t216 -126t146 -208t53.5 -281t-53.5 -281.5t-146 -208.5t-216 -126.5t-264.5 -44.5t-264.5 44.5t-216 126.5t-146 208.5t-53.5 281.5zM258 641q0 -255 143.5 -395t391.5 -140t391 140t143 395 q0 252 -143.5 392.5t-390.5 140.5t-391 -140.5t-144 -392.5zM401 641q0 106 33 187t90 127.5t125 69t146 22.5q153 0 264 -48v-122q-53 18 -75.5 24.5t-72 12.5t-118.5 6q-110 0 -179 -68t-69 -211q0 -144 69 -212.5t179 -68.5q69 0 118.5 6t72 12.5t75.5 24.5v-122 q-111 -48 -264 -48q-79 0 -147.5 23t-125 70t-89 127.5t-32.5 187.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordfeminine",
    unicode: "\xAA",
    horizAdvX: 757,
    d: "M61 1001q0 109 71 173t214 71l189 10v43q0 75 -36.5 109.5t-125.5 34.5q-114 0 -238 -43v112q110 45 238 45q86 0 145 -18t90.5 -54.5t44.5 -81.5t13 -108v-526h-86l-15 49q-120 -69 -223 -69q-148 0 -214.5 64.5t-66.5 188.5zM195 1001q0 -60 35 -99.5t116 -39.5 q92 0 189 53v240l-191 -16q-71 -6 -110 -42.5t-39 -95.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotleft",
    unicode: "\xAB",
    horizAdvX: 952,
    d: "M82 444v136l389 286v-135l-258 -219l258 -219v-137zM471 444v136l389 286v-135l-258 -219l258 -219v-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "logicalnot",
    unicode: "\xAC",
    horizAdvX: 1323,
    d: "M164 893v131h880v-586h-137v455h-743z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00AD",
    unicode: "\xAD",
    horizAdvX: 634,
    d: "M61 557v135h512v-135h-512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "registered",
    unicode: "\xAE",
    horizAdvX: 1585,
    d: "M113 641q0 155 53.5 281t146 208t216 126t264.5 44t264.5 -44t216 -126t146 -208t53.5 -281t-53.5 -281.5t-146 -208.5t-216 -126.5t-264.5 -44.5t-264.5 44.5t-216 126.5t-146 208.5t-53.5 281.5zM258 641q0 -255 143.5 -395t391.5 -140t391 140t143 395 q0 252 -143.5 392.5t-390.5 140.5t-391 -140.5t-144 -392.5zM510 254v770h328q70 0 121 -19.5t79.5 -54.5t42 -78t13.5 -96q0 -71 -30.5 -132t-88.5 -91l164 -299h-160l-141 274h-193v-274h-135zM645 651h197q106 0 106 125q0 123 -106 123h-197v-248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "macron",
    unicode: "\xAF",
    d: "M303 1270v123h561v-123h-561z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "degree",
    unicode: "\xB0",
    horizAdvX: 688,
    d: "M61 1280q0 78 24 134t66 86t89.5 43t103.5 13t103.5 -13t89.5 -43t66 -86t24 -134q0 -77 -24 -133t-66 -86t-89.5 -43.5t-103.5 -13.5t-103.5 13.5t-89.5 43.5t-66 86t-24 133zM182 1280q0 -164 162 -164t162 164t-162 164t-162 -164z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "plusminus",
    unicode: "\xB1",
    horizAdvX: 1003,
    d: "M92 154v135h819v-135h-819zM92 766v135h342v342h135v-342h342v-135h-342v-342h-135v342h-342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B2",
    unicode: "\xB2",
    horizAdvX: 851,
    d: "M72 698v103q128 84 197.5 130.5t139 97.5t99 78.5t55.5 60.5t32.5 58.5t6.5 59.5q0 141 -211 141q-119 0 -276 -45v125q51 20 132 34.5t142 14.5q183 0 265.5 -74.5t82.5 -197.5q0 -60 -26.5 -112t-103 -115t-128 -99t-183.5 -120q-17 -11 -26 -17h500v-123h-698z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B3",
    unicode: "\xB3",
    horizAdvX: 880,
    d: "M92 723v127q158 -47 334 -47q120 0 182 36.5t62 102.5q0 76 -39.5 105.5t-145.5 29.5h-239v119h237q87 0 120.5 29t33.5 92q0 54 -53.5 83.5t-161.5 29.5q-153 0 -316 -41v124q107 43 314 43q350 0 350 -239q0 -61 -26 -104t-62 -60q55 -20 91 -74.5t36 -138.5 q0 -121 -97.5 -191.5t-287.5 -70.5q-93 0 -186.5 12t-145.5 33z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acute",
    unicode: "\xB4",
    d: "M532 1126l103 410h164l-164 -410h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B5",
    unicode: "\xB5",
    horizAdvX: 972,
    d: "M123 -512v1536h143v-743q0 -95 52 -135t153 -40q94 0 155 15.5t122 50.5v852h143v-1024h-80l-31 86q-141 -106 -309 -106q-127 0 -205 38v-530h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "paragraph",
    unicode: "\xB6",
    horizAdvX: 1208,
    d: "M72 1075q0 75 16.5 140.5t54.5 125t96 102.5t146.5 68t200.5 25h469v-1536h-140v614h-157v-614h-140v614h-32q-112 0 -200.5 25t-146.5 68t-96 102.5t-54.5 125t-16.5 140.5zM223 1075q0 -49 7.5 -91.5t30.5 -88.5t59.5 -78t100 -53t146.5 -21h51v664h-51 q-83 0 -146.5 -21t-100 -53t-59.5 -78t-30.5 -88.5t-7.5 -91.5zM758 743h157v664h-157v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "periodcentered",
    unicode: "\xB7",
    horizAdvX: 327,
    d: "M92 625q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-73 30t-30 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "cedilla",
    unicode: "\xB8",
    d: "M410 -381q73 -27 157 -27q138 0 138 74q0 42 -27 70t-64.5 40t-91.5 19l21 205h82l10 -131q35 -9 65.5 -22.5t61.5 -36.5t49 -59t18 -81q0 -84 -60.5 -133t-166.5 -49q-121 0 -192 37v94z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00B9",
    unicode: "\xB9",
    horizAdvX: 593,
    d: "M76 1405v65l297 86h63v-858h-139v713z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ordmasculine",
    unicode: "\xBA",
    horizAdvX: 858,
    d: "M72 1153q0 201 84 302t266 101q364 0 364 -403q0 -405 -364 -405q-182 0 -266 102t-84 303zM199 1153q0 -152 53 -219.5t170 -67.5q121 0 180.5 69.5t59.5 217.5t-59.5 216.5t-180.5 68.5q-118 0 -170.5 -66.5t-52.5 -218.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guillemotright",
    unicode: "\xBB",
    horizAdvX: 952,
    d: "M92 156v135l258 219l-258 219v137l389 -288v-136zM481 156v135l258 219l-258 219v137l389 -288v-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onequarter",
    unicode: "\xBC",
    horizAdvX: 1910,
    d: "M76 1405v65l297 86h63v-858h-139v713zM246 0l1085 1536h158l-1086 -1536h-157zM1044 242v84l512 532h99v-491h174v-125h-174v-242h-133v242h-478zM1245 367h277v284z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "onehalf",
    unicode: "\xBD",
    horizAdvX: 1937,
    d: "M76 1405v65l297 86h63v-858h-139v713zM246 0l1085 1536h158l-1086 -1536h-157zM1178 0v102q127 84 197 131t139 97.5t99.5 78.5t56 61t32 58.5t6.5 59.5q0 141 -211 141q-119 0 -276 -45v125q51 20 132 34.5t142 14.5q183 0 265.5 -74.5t82.5 -197.5q0 -60 -26.5 -112 t-103 -115t-128 -99t-183.5 -120q-17 -11 -26 -17h500v-123h-698z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "threequarters",
    unicode: "\xBE",
    horizAdvX: 2177,
    d: "M92 723v127q158 -47 334 -47q120 0 182 36.5t62 102.5q0 76 -39.5 105.5t-145.5 29.5h-239v119h237q87 0 120.5 29t33.5 92q0 54 -53.5 83.5t-161.5 29.5q-153 0 -316 -41v124q107 43 314 43q350 0 350 -239q0 -61 -26 -104t-62 -60q55 -20 91 -74.5t36 -138.5 q0 -121 -97.5 -191.5t-287.5 -70.5q-93 0 -186.5 12t-145.5 33zM512 0l1085 1536h158l-1085 -1536h-158zM1311 242v84l512 532h98v-491h174v-125h-174v-242h-133v242h-477zM1511 367h277v284z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "questiondown",
    unicode: "\xBF",
    horizAdvX: 962,
    d: "M92 -127q0 54 9.5 100t25 81t43 66t55 53.5t71 46t80.5 40t93 39.5q37 15 63.5 31.5t43 39t26 41.5t13.5 53.5t5 58.5t1 71h75q8 -41 12.5 -70t5.5 -66.5t-5 -65.5t-20.5 -59.5t-38.5 -56t-62.5 -49t-89.5 -43.5q-115 -43 -158 -73q-107 -73 -111 -225v-11 q0 -69 15 -116.5t53.5 -87t112 -58.5t184.5 -19q186 0 317 48v-123q-49 -20 -145 -35.5t-170 -15.5q-105 0 -186.5 15t-135.5 44t-91 64.5t-56 84t-27 94.5t-8 103zM516 942q0 43 29.5 72.5t72.5 29.5t73 -29.5t30 -72.5t-30 -72.5t-73 -29.5t-72.5 29.5t-29.5 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Agrave",
    unicode: "\xC0",
    horizAdvX: 1290,
    d: "M51 0l543 1556h102l543 -1556h-158l-141 430h-590l-141 -430h-158zM389 551h510l-254 772zM410 1843h184l102 -205h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aacute",
    unicode: "\xC1",
    horizAdvX: 1290,
    d: "M51 0l543 1556h102l543 -1556h-158l-141 430h-590l-141 -430h-158zM389 551h510l-254 772zM594 1638l102 205h185l-185 -205h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Acircumflex",
    unicode: "\xC2",
    horizAdvX: 1290,
    d: "M51 0l543 1556h102l543 -1556h-158l-141 430h-590l-141 -430h-158zM328 1638l235 205h164l236 -205h-115l-203 115l-203 -115h-114zM389 551h510l-254 772z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Atilde",
    unicode: "\xC3",
    horizAdvX: 1290,
    d: "M51 0l543 1556h102l543 -1556h-158l-141 430h-590l-141 -430h-158zM274 1638q-7 106 53 166t171 60q49 0 94.5 -19.5t74 -43t64.5 -43t70 -19.5q100 0 100 104h115q7 -106 -52.5 -165.5t-170.5 -59.5q-49 0 -95 19.5t-74 43t-64.5 43t-70.5 19.5q-100 0 -100 -105h-115z M389 551h510l-254 772z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Adieresis",
    unicode: "\xC4",
    horizAdvX: 1290,
    d: "M51 0l543 1556h102l543 -1556h-158l-141 430h-590l-141 -430h-158zM348 1741q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-73 30t-30 73zM389 551h510l-254 772zM737 1741q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-73 30 t-30 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Aring",
    unicode: "\xC5",
    horizAdvX: 1290,
    d: "M51 0l543 1556h102l543 -1556h-158l-141 430h-590l-141 -430h-158zM389 551h510l-254 772zM453 1741q0 145 192 145q193 0 193 -145q0 -146 -193 -146q-192 0 -192 146zM555 1741q0 -45 90 -45t90 45t-90 45t-90 -45z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "AE",
    unicode: "\xC6",
    horizAdvX: 1996,
    d: "M41 0l770 1536h1063v-129h-901l88 -543h741v-129h-719l99 -606h692v-129h-811l-72 430h-588l-206 -430h-156zM463 551h510l-129 790z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ccedilla",
    unicode: "\xC7",
    horizAdvX: 1249,
    d: "M123 768q0 136 18.5 250t62.5 215.5t112 171.5t172.5 110.5t238.5 40.5q238 0 399 -71v-137q-107 43 -196 61t-203 18q-98 0 -176 -33t-130 -91.5t-86.5 -142.5t-49.5 -181t-15 -211t15 -211t49.5 -181t86.5 -142.5t130 -91.5t176 -33q114 0 203 18t196 61v-137 q-142 -64 -356 -69l8 -113q35 -9 66 -22.5t62 -36.5t49 -59t18 -81q0 -84 -60.5 -133t-167.5 -49q-121 0 -192 37v94q74 -27 158 -27q137 0 137 74q0 42 -27 70t-64 40t-91 19l18 187q-125 6 -222 49.5t-160 114t-104 170t-58 210t-17 242.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Egrave",
    unicode: "\xC8",
    d: "M154 0v1536h890v-129h-751v-543h680v-129h-680v-606h751v-129h-890zM379 1843h184l103 -205h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eacute",
    unicode: "\xC9",
    d: "M154 0v1536h890v-129h-751v-543h680v-129h-680v-606h751v-129h-890zM563 1638l103 205h184l-184 -205h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ecircumflex",
    unicode: "\xCA",
    d: "M154 0v1536h890v-129h-751v-543h680v-129h-680v-606h751v-129h-890zM297 1638l235 205h164l236 -205h-115l-203 115l-202 -115h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Edieresis",
    unicode: "\xCB",
    d: "M154 0v1536h890v-129h-751v-543h680v-129h-680v-606h751v-129h-890zM317 1741q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-73 30t-30 73zM707 1741q0 43 29.5 72.5t72.5 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-72.5 30t-29.5 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Igrave",
    unicode: "\xCC",
    horizAdvX: 532,
    d: "M31 1843h184l102 -205h-102zM195 0v1536h143v-1536h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Iacute",
    unicode: "\xCD",
    horizAdvX: 532,
    d: "M195 0v1536h143v-1536h-143zM215 1638l102 205h185l-185 -205h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Icircumflex",
    unicode: "\xCE",
    horizAdvX: 532,
    d: "M-51 1638l235 205h164l236 -205h-115l-203 115l-203 -115h-114zM195 0v1536h143v-1536h-143z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Idieresis",
    unicode: "\xCF",
    horizAdvX: 532,
    d: "M10 1741q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-73 30t-30 73zM195 0v1536h143v-1536h-143zM317 1741q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-73 30t-30 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Eth",
    unicode: "\xD0",
    horizAdvX: 1402,
    d: "M31 741v109h184v686h418q147 0 259.5 -38.5t185.5 -105.5t118.5 -166t64.5 -210t19 -248t-19 -248t-64.5 -210t-118.5 -166t-185.5 -105.5t-259.5 -38.5h-418v741h-184zM354 129h287q492 0 492 639t-492 639h-287v-557h375v-109h-375v-612z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ntilde",
    unicode: "\xD1",
    horizAdvX: 1372,
    d: "M154 0v1536h104l825 -1251l-4 1251h140v-1536h-105l-825 1251l4 -1251h-139zM315 1638q-7 106 53 166t171 60q49 0 94.5 -19.5t74 -43t64.5 -43t70 -19.5q100 0 100 104h115q7 -106 -52.5 -165.5t-170.5 -59.5q-49 0 -95 19.5t-74.5 43t-64.5 43t-70 19.5 q-100 0 -100 -105h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ograve",
    unicode: "\xD2",
    horizAdvX: 1392,
    d: "M123 768q0 94 5 170.5t20.5 160.5t41.5 148t70 124.5t103 99.5t143.5 62t189.5 23t189.5 -23t144 -62.5t103 -99t69.5 -124t41.5 -148.5t21 -160.5t5.5 -170.5t-5.5 -170.5t-21 -160.5t-41.5 -148.5t-69.5 -124t-103 -99t-144 -62.5t-189.5 -23t-189.5 23t-143.5 62 t-103 99.5t-70 124.5t-41.5 148t-20.5 160.5t-5 170.5zM270 768q0 -86 4 -153.5t15.5 -138t31 -123t52 -100.5t76.5 -78.5t106.5 -48t140.5 -17.5t140.5 17.5t106.5 48t76.5 78.5t52 100.5t31 123t15.5 138t4 153.5t-4 153.5t-15.5 138t-31 123t-52 100.5t-76.5 78.5 t-106.5 48t-140.5 17.5t-140.5 -17.5t-106.5 -48t-76.5 -78.5t-52 -100.5t-31 -123t-15.5 -138t-4 -153.5zM461 1843h184l103 -205h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oacute",
    unicode: "\xD3",
    horizAdvX: 1392,
    d: "M123 768q0 94 5 170.5t20.5 160.5t41.5 148t70 124.5t103 99.5t143.5 62t189.5 23t189.5 -23t144 -62.5t103 -99t69.5 -124t41.5 -148.5t21 -160.5t5.5 -170.5t-5.5 -170.5t-21 -160.5t-41.5 -148.5t-69.5 -124t-103 -99t-144 -62.5t-189.5 -23t-189.5 23t-143.5 62 t-103 99.5t-70 124.5t-41.5 148t-20.5 160.5t-5 170.5zM270 768q0 -86 4 -153.5t15.5 -138t31 -123t52 -100.5t76.5 -78.5t106.5 -48t140.5 -17.5t140.5 17.5t106.5 48t76.5 78.5t52 100.5t31 123t15.5 138t4 153.5t-4 153.5t-15.5 138t-31 123t-52 100.5t-76.5 78.5 t-106.5 48t-140.5 17.5t-140.5 -17.5t-106.5 -48t-76.5 -78.5t-52 -100.5t-31 -123t-15.5 -138t-4 -153.5zM645 1638l103 205h184l-184 -205h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ocircumflex",
    unicode: "\xD4",
    horizAdvX: 1392,
    d: "M123 768q0 94 5 170.5t20.5 160.5t41.5 148t70 124.5t103 99.5t143.5 62t189.5 23t189.5 -23t144 -62.5t103 -99t69.5 -124t41.5 -148.5t21 -160.5t5.5 -170.5t-5.5 -170.5t-21 -160.5t-41.5 -148.5t-69.5 -124t-103 -99t-144 -62.5t-189.5 -23t-189.5 23t-143.5 62 t-103 99.5t-70 124.5t-41.5 148t-20.5 160.5t-5 170.5zM270 768q0 -86 4 -153.5t15.5 -138t31 -123t52 -100.5t76.5 -78.5t106.5 -48t140.5 -17.5t140.5 17.5t106.5 48t76.5 78.5t52 100.5t31 123t15.5 138t4 153.5t-4 153.5t-15.5 138t-31 123t-52 100.5t-76.5 78.5 t-106.5 48t-140.5 17.5t-140.5 -17.5t-106.5 -48t-76.5 -78.5t-52 -100.5t-31 -123t-15.5 -138t-4 -153.5zM379 1638l235 205h164l236 -205h-115l-203 115l-202 -115h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Otilde",
    unicode: "\xD5",
    horizAdvX: 1392,
    d: "M123 768q0 94 5 170.5t20.5 160.5t41.5 148t70 124.5t103 99.5t143.5 62t189.5 23t189.5 -23t144 -62.5t103 -99t69.5 -124t41.5 -148.5t21 -160.5t5.5 -170.5t-5.5 -170.5t-21 -160.5t-41.5 -148.5t-69.5 -124t-103 -99t-144 -62.5t-189.5 -23t-189.5 23t-143.5 62 t-103 99.5t-70 124.5t-41.5 148t-20.5 160.5t-5 170.5zM270 768q0 -86 4 -153.5t15.5 -138t31 -123t52 -100.5t76.5 -78.5t106.5 -48t140.5 -17.5t140.5 17.5t106.5 48t76.5 78.5t52 100.5t31 123t15.5 138t4 153.5t-4 153.5t-15.5 138t-31 123t-52 100.5t-76.5 78.5 t-106.5 48t-140.5 17.5t-140.5 -17.5t-106.5 -48t-76.5 -78.5t-52 -100.5t-31 -123t-15.5 -138t-4 -153.5zM326 1638q-7 107 52.5 166.5t170.5 59.5q49 0 94.5 -19.5t74 -43t64.5 -43t70 -19.5q100 0 100 104h115q7 -106 -52.5 -165.5t-170.5 -59.5q-49 0 -94.5 19.5t-74 43 t-64.5 43t-70 19.5q-101 0 -101 -105h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Odieresis",
    unicode: "\xD6",
    horizAdvX: 1392,
    d: "M123 768q0 94 5 170.5t20.5 160.5t41.5 148t70 124.5t103 99.5t143.5 62t189.5 23t189.5 -23t144 -62.5t103 -99t69.5 -124t41.5 -148.5t21 -160.5t5.5 -170.5t-5.5 -170.5t-21 -160.5t-41.5 -148.5t-69.5 -124t-103 -99t-144 -62.5t-189.5 -23t-189.5 23t-143.5 62 t-103 99.5t-70 124.5t-41.5 148t-20.5 160.5t-5 170.5zM270 768q0 -86 4 -153.5t15.5 -138t31 -123t52 -100.5t76.5 -78.5t106.5 -48t140.5 -17.5t140.5 17.5t106.5 48t76.5 78.5t52 100.5t31 123t15.5 138t4 153.5t-4 153.5t-15.5 138t-31 123t-52 100.5t-76.5 78.5 t-106.5 48t-140.5 17.5t-140.5 -17.5t-106.5 -48t-76.5 -78.5t-52 -100.5t-31 -123t-15.5 -138t-4 -153.5zM399 1741q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-73 30t-30 73zM788 1741q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73 t-72.5 -30t-73 30t-30 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "multiply",
    unicode: "\xD7",
    horizAdvX: 1003,
    d: "M98 391l308 307l-308 308l97 96l307 -307l307 307l96 -96l-307 -308l307 -307l-96 -96l-307 307l-307 -307z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Oslash",
    unicode: "\xD8",
    horizAdvX: 1351,
    d: "M123 768q0 94 5 170.5t20.5 160.5t41.5 148t70 124.5t103 99.5t143.5 62t189.5 23q219 0 355 -102l49 82h129l-99 -162q80 -104 110 -256.5t30 -349.5q0 -94 -5.5 -170.5t-21 -160.5t-41.5 -148.5t-69.5 -124t-103 -99t-144 -62.5t-189.5 -23q-221 0 -354 100l-49 -80 h-129l98 160q-81 105 -110 256t-29 352zM270 768q0 -327 74 -471l633 1036q-100 94 -281 94q-78 0 -140.5 -17.5t-106.5 -48t-76.5 -78.5t-52 -100.5t-31 -123t-15.5 -138t-4 -153.5zM416 201q98 -92 280 -92q78 0 140.5 17.5t106.5 48t76.5 78.5t52 100.5t31 123t15.5 138 t4 153.5q0 323 -75 469z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ugrave",
    unicode: "\xD9",
    horizAdvX: 1372,
    d: "M143 481v1055h140v-1032q0 -395 403 -395q404 0 404 395v1032h139v-1055q0 -90 -21 -164.5t-54.5 -125.5t-80.5 -90t-95.5 -61.5t-104 -36.5t-99.5 -18.5t-88 -4.5t-88 4.5t-99.5 18.5t-104 36.5t-95.5 61.5t-80.5 90t-54.5 125.5t-21 164.5zM451 1843h184l102 -205h-102 z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Uacute",
    unicode: "\xDA",
    horizAdvX: 1372,
    d: "M143 481v1055h140v-1032q0 -395 403 -395q404 0 404 395v1032h139v-1055q0 -90 -21 -164.5t-54.5 -125.5t-80.5 -90t-95.5 -61.5t-104 -36.5t-99.5 -18.5t-88 -4.5t-88 4.5t-99.5 18.5t-104 36.5t-95.5 61.5t-80.5 90t-54.5 125.5t-21 164.5zM635 1638l102 205h185 l-185 -205h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ucircumflex",
    unicode: "\xDB",
    horizAdvX: 1372,
    d: "M143 481v1055h140v-1032q0 -395 403 -395q404 0 404 395v1032h139v-1055q0 -90 -21 -164.5t-54.5 -125.5t-80.5 -90t-95.5 -61.5t-104 -36.5t-99.5 -18.5t-88 -4.5t-88 4.5t-99.5 18.5t-104 36.5t-95.5 61.5t-80.5 90t-54.5 125.5t-21 164.5zM369 1638l235 205h164 l236 -205h-115l-203 115l-203 -115h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Udieresis",
    unicode: "\xDC",
    horizAdvX: 1372,
    d: "M143 481v1055h140v-1032q0 -395 403 -395q404 0 404 395v1032h139v-1055q0 -90 -21 -164.5t-54.5 -125.5t-80.5 -90t-95.5 -61.5t-104 -36.5t-99.5 -18.5t-88 -4.5t-88 4.5t-99.5 18.5t-104 36.5t-95.5 61.5t-80.5 90t-54.5 125.5t-21 164.5zM389 1741q0 43 30 72.5 t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-73 30t-30 73zM778 1741q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-73 30t-30 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Yacute",
    unicode: "\xDD",
    horizAdvX: 1372,
    d: "M61 1536h154l471 -788l471 788h154l-555 -901v-635h-140v635zM635 1638l102 205h185l-185 -205h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Thorn",
    unicode: "\xDE",
    d: "M154 0v1536h139v-307h330q112 0 200.5 -25t146.5 -68t96 -102.5t54.5 -125t16.5 -140.5t-16.5 -140.5t-54.5 -125t-96 -102.5t-146.5 -68t-200.5 -25h-330v-307h-139zM293 436h348q83 0 146.5 21t100 53t59.5 78t30.5 88.5t7.5 91.5t-7.5 91.5t-30.5 88.5t-59.5 78 t-100 53t-146.5 21h-348v-664z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "germandbls",
    unicode: "\xDF",
    horizAdvX: 1101,
    d: "M172 0v1249q0 149 93.5 228t275.5 79q181 0 271.5 -78.5t90.5 -228.5q0 -64 -17.5 -115t-45.5 -84t-62 -59.5t-67.5 -49t-61.5 -46.5t-45.5 -57.5t-17.5 -75.5q0 -65 34.5 -98.5t135.5 -65.5q164 -53 229.5 -117t65.5 -188q0 -62 -18.5 -116t-57.5 -99.5t-107 -71.5 t-159 -26q-154 0 -250 55v123q142 -52 250 -52q60 0 102 15t63.5 42t30 58t8.5 70q0 75 -37.5 113t-152.5 73q-154 46 -212 109.5t-58 175.5q0 58 17.5 103.5t45.5 75t62.5 54t68.5 48t62 49.5t45.5 66t17.5 91q0 94 -63.5 137.5t-167.5 43.5t-168 -43.5t-64 -137.5v-1249 h-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "agrave",
    unicode: "\xE0",
    horizAdvX: 1013,
    d: "M102 309q0 298 365 320l270 16v57q0 116 -52.5 166t-190.5 50q-154 0 -308 -52v123q127 55 308 55q112 0 189.5 -24t119.5 -71.5t60 -107.5t18 -141v-700h-80l-31 82q-138 -102 -309 -102q-97 0 -168.5 26.5t-112 74t-59.5 104t-19 124.5zM248 309q0 -32 3.5 -57t17 -54 t36 -47.5t63.5 -31.5t97 -13q78 0 138.5 20t133.5 62v357l-280 -27q-209 -20 -209 -209zM279 1536h163l103 -410h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aacute",
    unicode: "\xE1",
    horizAdvX: 1013,
    d: "M102 309q0 298 365 320l270 16v57q0 116 -52.5 166t-190.5 50q-154 0 -308 -52v123q127 55 308 55q112 0 189.5 -24t119.5 -71.5t60 -107.5t18 -141v-700h-80l-31 82q-138 -102 -309 -102q-97 0 -168.5 26.5t-112 74t-59.5 104t-19 124.5zM248 309q0 -32 3.5 -57t17 -54 t36 -47.5t63.5 -31.5t97 -13q78 0 138.5 20t133.5 62v357l-280 -27q-209 -20 -209 -209zM442 1126l103 410h164l-164 -410h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "acircumflex",
    unicode: "\xE2",
    horizAdvX: 1013,
    d: "M102 309q0 298 365 320l270 16v57q0 116 -52.5 166t-190.5 50q-154 0 -308 -52v123q127 55 308 55q112 0 189.5 -24t119.5 -71.5t60 -107.5t18 -141v-700h-80l-31 82q-138 -102 -309 -102q-97 0 -168.5 26.5t-112 74t-59.5 104t-19 124.5zM115 1126l297 410h163l297 -410 h-112l-266 289l-267 -289h-112zM248 309q0 -32 3.5 -57t17 -54t36 -47.5t63.5 -31.5t97 -13q78 0 138.5 20t133.5 62v357l-280 -27q-209 -20 -209 -209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "atilde",
    unicode: "\xE3",
    horizAdvX: 1013,
    d: "M102 309q0 298 365 320l270 16v57q0 116 -52.5 166t-190.5 50q-154 0 -308 -52v123q127 55 308 55q112 0 189.5 -24t119.5 -71.5t60 -107.5t18 -141v-700h-80l-31 82q-138 -102 -309 -102q-97 0 -168.5 26.5t-112 74t-59.5 104t-19 124.5zM123 1239q-7 106 52.5 165.5 t170.5 59.5q46 0 84 -15t63.5 -36t48 -42.5t49.5 -36.5t58 -15q101 0 101 104h114q7 -106 -52.5 -165.5t-170.5 -59.5q-46 0 -84 15t-63.5 36t-48 42.5t-49.5 36.5t-58 15q-100 0 -100 -104h-115zM248 309q0 -32 3.5 -57t17 -54t36 -47.5t63.5 -31.5t97 -13q78 0 138.5 20 t133.5 62v357l-280 -27q-209 -20 -209 -209z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "adieresis",
    unicode: "\xE4",
    horizAdvX: 1013,
    d: "M102 309q0 298 365 320l270 16v57q0 116 -52.5 166t-190.5 50q-154 0 -308 -52v123q127 55 308 55q112 0 189.5 -24t119.5 -71.5t60 -107.5t18 -141v-700h-80l-31 82q-138 -102 -309 -102q-97 0 -168.5 26.5t-112 74t-59.5 104t-19 124.5zM197 1331q0 43 29.5 73t72.5 30 t72.5 -30t29.5 -73t-29.5 -72.5t-72.5 -29.5t-72.5 29.5t-29.5 72.5zM248 309q0 -32 3.5 -57t17 -54t36 -47.5t63.5 -31.5t97 -13q78 0 138.5 20t133.5 62v357l-280 -27q-209 -20 -209 -209zM586 1331q0 43 29.5 73t72.5 30t73 -30t30 -73t-30 -72.5t-73 -29.5t-72.5 29.5 t-29.5 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "aring",
    unicode: "\xE5",
    horizAdvX: 1013,
    d: "M102 309q0 298 365 320l270 16v57q0 116 -52.5 166t-190.5 50q-154 0 -308 -52v123q127 55 308 55q112 0 189.5 -24t119.5 -71.5t60 -107.5t18 -141v-700h-80l-31 82q-138 -102 -309 -102q-97 0 -168.5 26.5t-112 74t-59.5 104t-19 124.5zM248 309q0 -32 3.5 -57t17 -54 t36 -47.5t63.5 -31.5t97 -13q78 0 138.5 20t133.5 62v357l-280 -27q-209 -20 -209 -209zM281 1331q0 102 58.5 154.5t154.5 52.5t154.5 -52.5t58.5 -154.5t-58.5 -154.5t-154.5 -52.5t-154.5 52.5t-58.5 154.5zM383 1331q0 -54 30.5 -80t80.5 -26t80 26t30 80t-30 80.5 t-80 26.5t-80.5 -26.5t-30.5 -80.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ae",
    unicode: "\xE6",
    horizAdvX: 1710,
    d: "M102 289q0 64 17 112.5t57.5 89.5t116.5 62.5t186 21.5h299v127q0 114 -61 165t-207 51q-170 0 -324 -52v123q127 55 324 55q274 0 362 -141q106 141 336 141q85 0 149.5 -18t106.5 -55t69 -81.5t40.5 -109.5t18.5 -125.5t5 -142.5v-53h-675v-13q3 -59 10.5 -104.5 t27 -91.5t50 -76t81 -49t117.5 -19q111 0 187 13t151 45v-123q-138 -61 -338 -61q-227 0 -334 139l-63 -49q-122 -90 -322 -90q-197 0 -292 84.5t-95 224.5zM248 289q0 -183 246 -183q84 0 161.5 26t126.5 67l35 30q-33 97 -39 228v2h-309q-123 0 -172 -44t-49 -126z M922 575h532q-1 44 -2.5 75t-7 69.5t-16 65t-28.5 53.5t-43.5 43t-63 26.5t-85.5 10.5q-68 0 -118.5 -19t-80.5 -49.5t-49.5 -77.5t-27 -92.5t-10.5 -104.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ccedilla",
    unicode: "\xE7",
    horizAdvX: 942,
    d: "M113 512q0 94 11.5 169.5t41 145t77.5 116t124.5 74t177.5 27.5q187 0 305 -51v-123q-142 48 -307 48q-63 0 -111 -15.5t-78.5 -45.5t-50.5 -65.5t-30 -85t-13.5 -93.5t-3.5 -101t3.5 -101t13.5 -93.5t30 -85t50.5 -65.5t78.5 -45.5t111 -15.5q165 0 307 48v-123 q-114 -47 -283 -51l8 -111q35 -9 66 -22.5t62 -36.5t49 -59t18 -81q0 -84 -60.5 -133t-166.5 -49q-122 0 -193 37v94q74 -27 158 -27q137 0 137 74q0 42 -27 70t-64 40t-91 19l18 189q-86 8 -150.5 39.5t-105.5 78t-66.5 113.5t-35.5 138.5t-10 158.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "egrave",
    unicode: "\xE8",
    horizAdvX: 1044,
    d: "M113 512q0 94 11.5 169.5t40.5 145t76.5 116t124 74t177.5 27.5q85 0 149.5 -18t106.5 -55t69 -81.5t40.5 -109.5t18.5 -125.5t5 -142.5v-66h-676q3 -58 11 -104t27.5 -92t50 -76t81 -49t117.5 -19q111 0 187 13t151 45v-123q-138 -61 -338 -61q-101 0 -177.5 27.5 t-124 74t-76.5 116t-40.5 145t-11.5 169.5zM256 563h532q0 47 -1 77.5t-6.5 72t-15 67.5t-27.5 55t-43.5 45t-64 27t-87.5 11q-69 0 -120.5 -20t-82 -51.5t-49.5 -80t-26 -95.5t-9 -108zM328 1536h164l102 -410h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eacute",
    unicode: "\xE9",
    horizAdvX: 1044,
    d: "M113 512q0 94 11.5 169.5t40.5 145t76.5 116t124 74t177.5 27.5q85 0 149.5 -18t106.5 -55t69 -81.5t40.5 -109.5t18.5 -125.5t5 -142.5v-66h-676q3 -58 11 -104t27.5 -92t50 -76t81 -49t117.5 -19q111 0 187 13t151 45v-123q-138 -61 -338 -61q-101 0 -177.5 27.5 t-124 74t-76.5 116t-40.5 145t-11.5 169.5zM256 563h532q0 47 -1 77.5t-6.5 72t-15 67.5t-27.5 55t-43.5 45t-64 27t-87.5 11q-69 0 -120.5 -20t-82 -51.5t-49.5 -80t-26 -95.5t-9 -108zM492 1126l102 410h164l-164 -410h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ecircumflex",
    unicode: "\xEA",
    horizAdvX: 1044,
    d: "M113 512q0 94 11.5 169.5t40.5 145t76.5 116t124 74t177.5 27.5q85 0 149.5 -18t106.5 -55t69 -81.5t40.5 -109.5t18.5 -125.5t5 -142.5v-66h-676q3 -58 11 -104t27.5 -92t50 -76t81 -49t117.5 -19q111 0 187 13t151 45v-123q-138 -61 -338 -61q-101 0 -177.5 27.5 t-124 74t-76.5 116t-40.5 145t-11.5 169.5zM164 1126l297 410h164l297 -410h-113l-266 289l-267 -289h-112zM256 563h532q0 47 -1 77.5t-6.5 72t-15 67.5t-27.5 55t-43.5 45t-64 27t-87.5 11q-69 0 -120.5 -20t-82 -51.5t-49.5 -80t-26 -95.5t-9 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "edieresis",
    unicode: "\xEB",
    horizAdvX: 1044,
    d: "M113 512q0 94 11.5 169.5t40.5 145t76.5 116t124 74t177.5 27.5q85 0 149.5 -18t106.5 -55t69 -81.5t40.5 -109.5t18.5 -125.5t5 -142.5v-66h-676q3 -58 11 -104t27.5 -92t50 -76t81 -49t117.5 -19q111 0 187 13t151 45v-123q-138 -61 -338 -61q-101 0 -177.5 27.5 t-124 74t-76.5 116t-40.5 145t-11.5 169.5zM246 1331q0 43 29.5 73t72.5 30t73 -30t30 -73t-30 -72.5t-73 -29.5t-72.5 29.5t-29.5 72.5zM256 563h532q0 47 -1 77.5t-6.5 72t-15 67.5t-27.5 55t-43.5 45t-64 27t-87.5 11q-69 0 -120.5 -20t-82 -51.5t-49.5 -80t-26 -95.5 t-9 -108zM635 1331q0 43 29.5 73t72.5 30t73 -30t30 -73t-30 -72.5t-73 -29.5t-72.5 29.5t-29.5 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "igrave",
    unicode: "\xEC",
    horizAdvX: 491,
    d: "M20 1536h164l103 -410h-103zM166 205v819h139v-836q0 -53 19 -72.5t67 -19.5v-116q-114 0 -169.5 52.5t-55.5 172.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "iacute",
    unicode: "\xED",
    horizAdvX: 491,
    d: "M166 205v819h139v-836q0 -53 19 -72.5t67 -19.5v-116q-114 0 -169.5 52.5t-55.5 172.5zM184 1126l103 410h164l-164 -410h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "icircumflex",
    unicode: "\xEE",
    horizAdvX: 491,
    d: "M-143 1126l297 410h163l297 -410h-112l-266 289l-267 -289h-112zM166 205v819h139v-836q0 -53 19 -72.5t67 -19.5v-116q-114 0 -169.5 52.5t-55.5 172.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "idieresis",
    unicode: "\xEF",
    horizAdvX: 491,
    d: "M-20 1331q0 43 29.5 73t72.5 30t72.5 -30t29.5 -73t-29.5 -72.5t-72.5 -29.5t-72.5 29.5t-29.5 72.5zM166 205v819h139v-836q0 -53 19 -72.5t67 -19.5v-116q-114 0 -169.5 52.5t-55.5 172.5zM287 1331q0 43 29.5 73t72.5 30t73 -30t30 -73t-30 -72.5t-73 -29.5 t-72.5 29.5t-29.5 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "eth",
    unicode: "\xF0",
    horizAdvX: 1126,
    d: "M113 512q0 98 13 176t45 146t82.5 113.5t128.5 71t181 25.5q119 0 217 -53q-62 149 -190 281l-314 -160v121l230 117q-110 94 -277 186h234q105 -66 168 -123l239 123v-121l-157 -80q289 -314 301 -823q0 -98 -13 -176t-44.5 -146t-82.5 -113.5t-129.5 -71t-181.5 -25.5 t-181 25.5t-128.5 71t-82.5 113.5t-45 146t-13 176zM256 512q0 -77 6 -132t24.5 -110t51.5 -88.5t89.5 -54.5t135.5 -21q78 0 134 21t89 55t52.5 88.5t25.5 110t6 131.5t-6 131.5t-25.5 110t-52.5 88.5t-89 55t-134 21q-79 0 -135.5 -21t-89.5 -54.5t-51.5 -88.5t-24.5 -110 t-6 -132z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ntilde",
    unicode: "\xF1",
    horizAdvX: 1024,
    d: "M133 0v1024h80l31 -86q141 106 309 106q348 0 348 -307v-737h-143v743q0 95 -52 135t-153 40q-94 0 -155 -15.5t-122 -50.5v-852h-143zM152 1239q-7 106 52.5 165.5t170.5 59.5q46 0 84 -15t63.5 -36t48 -42.5t49.5 -36.5t58 -15q100 0 100 104h115q7 -106 -52.5 -165.5 t-170.5 -59.5q-46 0 -84 15t-63.5 36t-48 42.5t-49.5 36.5t-58 15q-101 0 -101 -104h-114z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ograve",
    unicode: "\xF2",
    horizAdvX: 1085,
    d: "M113 512q0 100 11 176.5t40 145.5t76.5 113.5t123.5 70.5t179 26t179.5 -26t124 -70.5t76.5 -113.5t39.5 -145.5t10.5 -176.5t-10.5 -176.5t-39.5 -145.5t-76.5 -113.5t-124 -70.5t-179.5 -26t-179 26t-123.5 70.5t-76.5 113.5t-40 145.5t-11 176.5zM256 512 q0 -57 1.5 -95.5t8 -85t18.5 -77t33 -61t51 -48t74 -28.5t101 -11q56 0 99.5 11t73.5 28.5t51 48t33 61t18.5 76.5t8.5 85.5t2 95.5t-2 95.5t-8.5 85.5t-18.5 76.5t-33 61t-51 48t-73.5 28.5t-99.5 11q-57 0 -101 -11t-74 -28.5t-51 -48t-33 -61t-18.5 -77t-8 -85 t-1.5 -95.5zM328 1536h164l102 -410h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oacute",
    unicode: "\xF3",
    horizAdvX: 1085,
    d: "M113 512q0 100 11 176.5t40 145.5t76.5 113.5t123.5 70.5t179 26t179.5 -26t124 -70.5t76.5 -113.5t39.5 -145.5t10.5 -176.5t-10.5 -176.5t-39.5 -145.5t-76.5 -113.5t-124 -70.5t-179.5 -26t-179 26t-123.5 70.5t-76.5 113.5t-40 145.5t-11 176.5zM256 512 q0 -57 1.5 -95.5t8 -85t18.5 -77t33 -61t51 -48t74 -28.5t101 -11q56 0 99.5 11t73.5 28.5t51 48t33 61t18.5 76.5t8.5 85.5t2 95.5t-2 95.5t-8.5 85.5t-18.5 76.5t-33 61t-51 48t-73.5 28.5t-99.5 11q-57 0 -101 -11t-74 -28.5t-51 -48t-33 -61t-18.5 -77t-8 -85 t-1.5 -95.5zM492 1126l102 410h164l-164 -410h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ocircumflex",
    unicode: "\xF4",
    horizAdvX: 1085,
    d: "M113 512q0 100 11 176.5t40 145.5t76.5 113.5t123.5 70.5t179 26t179.5 -26t124 -70.5t76.5 -113.5t39.5 -145.5t10.5 -176.5t-10.5 -176.5t-39.5 -145.5t-76.5 -113.5t-124 -70.5t-179.5 -26t-179 26t-123.5 70.5t-76.5 113.5t-40 145.5t-11 176.5zM164 1126l297 410 h164l297 -410h-113l-266 289l-267 -289h-112zM256 512q0 -57 1.5 -95.5t8 -85t18.5 -77t33 -61t51 -48t74 -28.5t101 -11q56 0 99.5 11t73.5 28.5t51 48t33 61t18.5 76.5t8.5 85.5t2 95.5t-2 95.5t-8.5 85.5t-18.5 76.5t-33 61t-51 48t-73.5 28.5t-99.5 11q-57 0 -101 -11 t-74 -28.5t-51 -48t-33 -61t-18.5 -77t-8 -85t-1.5 -95.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "otilde",
    unicode: "\xF5",
    horizAdvX: 1085,
    d: "M113 512q0 100 11 176.5t40 145.5t76.5 113.5t123.5 70.5t179 26t179.5 -26t124 -70.5t76.5 -113.5t39.5 -145.5t10.5 -176.5t-10.5 -176.5t-39.5 -145.5t-76.5 -113.5t-124 -70.5t-179.5 -26t-179 26t-123.5 70.5t-76.5 113.5t-40 145.5t-11 176.5zM172 1239 q-7 106 52.5 165.5t170.5 59.5q46 0 84 -15t63.5 -36t48 -42.5t49.5 -36.5t58 -15q101 0 101 104h114q7 -106 -52.5 -165.5t-170.5 -59.5q-46 0 -84 15t-63.5 36t-48 42.5t-49.5 36.5t-58 15q-100 0 -100 -104h-115zM256 512q0 -57 1.5 -95.5t8 -85t18.5 -77t33 -61t51 -48 t74 -28.5t101 -11q56 0 99.5 11t73.5 28.5t51 48t33 61t18.5 76.5t8.5 85.5t2 95.5t-2 95.5t-8.5 85.5t-18.5 76.5t-33 61t-51 48t-73.5 28.5t-99.5 11q-57 0 -101 -11t-74 -28.5t-51 -48t-33 -61t-18.5 -77t-8 -85t-1.5 -95.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "odieresis",
    unicode: "\xF6",
    horizAdvX: 1085,
    d: "M113 512q0 100 11 176.5t40 145.5t76.5 113.5t123.5 70.5t179 26t179.5 -26t124 -70.5t76.5 -113.5t39.5 -145.5t10.5 -176.5t-10.5 -176.5t-39.5 -145.5t-76.5 -113.5t-124 -70.5t-179.5 -26t-179 26t-123.5 70.5t-76.5 113.5t-40 145.5t-11 176.5zM246 1331 q0 43 29.5 73t72.5 30t73 -30t30 -73t-30 -72.5t-73 -29.5t-72.5 29.5t-29.5 72.5zM256 512q0 -57 1.5 -95.5t8 -85t18.5 -77t33 -61t51 -48t74 -28.5t101 -11q56 0 99.5 11t73.5 28.5t51 48t33 61t18.5 76.5t8.5 85.5t2 95.5t-2 95.5t-8.5 85.5t-18.5 76.5t-33 61t-51 48 t-73.5 28.5t-99.5 11q-57 0 -101 -11t-74 -28.5t-51 -48t-33 -61t-18.5 -77t-8 -85t-1.5 -95.5zM635 1331q0 43 29.5 73t72.5 30t73 -30t30 -73t-30 -72.5t-73 -29.5t-72.5 29.5t-29.5 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "divide",
    unicode: "\xF7",
    horizAdvX: 1003,
    d: "M92 631v135h819v-135h-819zM399 371q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-73 30t-30 73zM399 1026q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -72.5t-72.5 -29.5t-73 29.5t-30 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oslash",
    unicode: "\xF8",
    horizAdvX: 1085,
    d: "M113 512q0 100 11 176.5t40 145.5t76.5 113.5t123.5 70.5t179 26q157 0 256 -61l26 41h127l-75 -113q96 -122 96 -399q0 -100 -10.5 -176.5t-39.5 -145.5t-76.5 -113.5t-124 -70.5t-179.5 -26q-164 0 -256 59l-27 -39h-127l76 111q-96 122 -96 401zM256 512 q0 -102 6.5 -166t28.5 -113l432 639q-68 46 -180 46q-57 0 -101 -11t-74 -28.5t-51 -48t-33 -61t-18.5 -77t-8 -85t-1.5 -95.5zM360 150q65 -44 183 -44q56 0 99.5 11t73.5 28.5t51 48t33 61t18.5 76.5t8.5 85.5t2 95.5q0 98 -7 162.5t-29 113.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ugrave",
    unicode: "\xF9",
    horizAdvX: 1024,
    d: "M123 287v737h143v-743q0 -95 52 -135t153 -40q94 0 155 15.5t122 50.5v852h143v-1024h-80l-31 86q-141 -106 -309 -106q-348 0 -348 307zM291 1536h164l102 -410h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uacute",
    unicode: "\xFA",
    horizAdvX: 1024,
    d: "M123 287v737h143v-743q0 -95 52 -135t153 -40q94 0 155 15.5t122 50.5v852h143v-1024h-80l-31 86q-141 -106 -309 -106q-348 0 -348 307zM455 1126l102 410h164l-164 -410h-102z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ucircumflex",
    unicode: "\xFB",
    horizAdvX: 1024,
    d: "M123 287v737h143v-743q0 -95 52 -135t153 -40q94 0 155 15.5t122 50.5v852h143v-1024h-80l-31 86q-141 -106 -309 -106q-348 0 -348 307zM127 1126l297 410h164l297 -410h-113l-266 289l-266 -289h-113z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "udieresis",
    unicode: "\xFC",
    horizAdvX: 1024,
    d: "M123 287v737h143v-743q0 -95 52 -135t153 -40q94 0 155 15.5t122 50.5v852h143v-1024h-80l-31 86q-141 -106 -309 -106q-348 0 -348 307zM209 1331q0 43 29.5 73t72.5 30t73 -30t30 -73t-30 -72.5t-73 -29.5t-72.5 29.5t-29.5 72.5zM598 1331q0 43 29.5 73t72.5 30 t73 -30t30 -73t-30 -72.5t-73 -29.5t-72.5 29.5t-29.5 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "yacute",
    unicode: "\xFD",
    horizAdvX: 983,
    d: "M41 1024h164l287 -840l286 840h164l-590 -1536h-153l231 539zM440 1126l103 410h164l-164 -410h-103z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "thorn",
    unicode: "\xFE",
    horizAdvX: 1095,
    d: "M133 -512v2048h143v-575q128 83 287 83q96 0 170 -27.5t120.5 -74.5t76 -116t41.5 -145t12 -169t-12 -169t-41.5 -145t-76 -116t-120.5 -74.5t-170 -27.5q-159 0 -287 83v-575h-143zM276 172q64 -34 128 -50t159 -16q71 0 123 23.5t81 60t46 93t22 108.5t5 121t-5 121 t-22 108.5t-46 93t-81 60t-123 23.5q-95 0 -159 -16t-128 -50v-680z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ydieresis",
    unicode: "\xFF",
    horizAdvX: 983,
    d: "M41 1024h164l287 -840l286 840h164l-590 -1536h-153l231 539zM195 1331q0 43 29.5 73t72.5 30t72.5 -30t29.5 -73t-29.5 -72.5t-72.5 -29.5t-72.5 29.5t-29.5 72.5zM584 1331q0 43 29.5 73t72.5 30t72.5 -30t29.5 -73t-29.5 -72.5t-72.5 -29.5t-72.5 29.5t-29.5 72.5z "
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "OE",
    unicode: "\u0152",
    horizAdvX: 1822,
    d: "M123 768q0 137 19 248t64.5 210t118.5 166t185.5 105.5t259.5 38.5h930v-129h-666v-543h594v-129h-594v-606h666v-129h-930q-147 0 -259.5 38.5t-185.5 105.5t-118.5 166t-64.5 210t-19 248zM270 768q0 -639 492 -639h133v1278h-133q-492 0 -492 -639z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "oe",
    unicode: "\u0153",
    horizAdvX: 1761,
    d: "M113 512q0 100 11 176.5t40 145.5t76.5 113.5t123.5 70.5t179 26q264 0 360 -172q102 172 357 172q85 0 149.5 -18t106.5 -55t69 -81.5t40.5 -109.5t18.5 -125.5t5 -142.5v-66h-676q3 -58 11 -104t27.5 -92t50 -76t81 -49t117.5 -19q111 0 186.5 13t150.5 45v-123 q-138 -61 -337 -61q-255 0 -357 172q-96 -172 -360 -172q-103 0 -179 26t-123.5 70.5t-76.5 113.5t-40 145.5t-11 176.5zM256 512q0 -57 1.5 -95.5t8 -85t18.5 -77t33 -61t51 -48t74 -28.5t101 -11q56 0 99.5 11t73.5 28.5t51 48t33 61t18.5 76.5t8.5 85.5t2 95.5t-2 95.5 t-8.5 85.5t-18.5 76.5t-33 61t-51 48t-73.5 28.5t-99.5 11q-57 0 -101 -11t-74 -28.5t-51 -48t-33 -61t-18.5 -77t-8 -85t-1.5 -95.5zM973 563h532q0 47 -1 77.5t-6.5 72t-15 67.5t-27.5 55t-43.5 45t-64 27t-87.5 11q-69 0 -120.5 -20t-82 -51.5t-49.5 -80t-26 -95.5 t-9 -108z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Ydieresis",
    unicode: "\u0178",
    horizAdvX: 1372,
    d: "M61 1536h154l471 -788l471 788h154l-555 -901v-635h-140v635zM389 1741q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-73 30t-30 73zM778 1741q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5t-29.5 -73t-72.5 -30t-73 30t-30 73z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "circumflex",
    unicode: "\u02C6",
    d: "M205 1126l297 410h164l297 -410h-113l-266 289l-267 -289h-112z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "tilde",
    unicode: "\u02DC",
    d: "M213 1239q-7 106 52.5 165.5t170.5 59.5q46 0 84 -15t63.5 -36t48 -42.5t49.5 -36.5t58 -15q101 0 101 104h114q7 -106 -52.5 -165.5t-170.5 -59.5q-46 0 -84 15t-63.5 36t-48 42.5t-49.5 36.5t-58 15q-100 0 -100 -104h-115z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2000",
    unicode: "\u2000",
    horizAdvX: 943
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2001",
    unicode: "\u2001",
    horizAdvX: 1886
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2002",
    unicode: "\u2002",
    horizAdvX: 943
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2003",
    unicode: "\u2003",
    horizAdvX: 1886
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2004",
    unicode: "\u2004",
    horizAdvX: 628
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2005",
    unicode: "\u2005",
    horizAdvX: 471
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2006",
    unicode: "\u2006",
    horizAdvX: 314
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2007",
    unicode: "\u2007",
    horizAdvX: 314
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2008",
    unicode: "\u2008",
    horizAdvX: 235
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2009",
    unicode: "\u2009",
    horizAdvX: 377
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni200A",
    unicode: "\u200A",
    horizAdvX: 104
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2010",
    unicode: "\u2010",
    horizAdvX: 634,
    d: "M61 557v135h512v-135h-512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni2011",
    unicode: "\u2011",
    horizAdvX: 634,
    d: "M61 557v135h512v-135h-512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "figuredash",
    unicode: "\u2012",
    horizAdvX: 634,
    d: "M61 557v135h512v-135h-512z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "endash",
    unicode: "\u2013",
    horizAdvX: 1024,
    d: "M92 557v135h840v-135h-840z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "emdash",
    unicode: "\u2014",
    horizAdvX: 2048,
    d: "M92 557v135h1864v-135h-1864z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteleft",
    unicode: "\u2018",
    horizAdvX: 307,
    d: "M-14 1024l164 512h90l-60 -512h-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quoteright",
    unicode: "\u2019",
    horizAdvX: 307,
    d: "M68 1024l59 512h195l-164 -512h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotesinglbase",
    unicode: "\u201A",
    horizAdvX: 307,
    d: "M47 -358l59 512h195l-164 -512h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblleft",
    unicode: "\u201C",
    horizAdvX: 614,
    d: "M-14 1024l164 512h90l-60 -512h-194zM293 1024l164 512h90l-60 -512h-194z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblright",
    unicode: "\u201D",
    horizAdvX: 614,
    d: "M68 1024l59 512h195l-164 -512h-90zM375 1024l59 512h195l-164 -512h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "quotedblbase",
    unicode: "\u201E",
    horizAdvX: 614,
    d: "M47 -358l59 512h195l-164 -512h-90zM354 -358l60 512h194l-164 -512h-90z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "bullet",
    unicode: "\u2022",
    horizAdvX: 757,
    d: "M102 768q0 115 80.5 195.5t196.5 80.5q115 0 195.5 -80t80.5 -196t-80.5 -196t-195.5 -80q-116 0 -196.5 80.5t-80.5 195.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "ellipsis",
    unicode: "\u2026",
    horizAdvX: 1966,
    d: "M205 82q0 43 29.5 72.5t72.5 29.5t73 -29.5t30 -72.5t-30 -72.5t-73 -29.5t-72.5 29.5t-29.5 72.5zM881 82q0 43 29.5 72.5t72.5 29.5t72.5 -29.5t29.5 -72.5t-29.5 -72.5t-72.5 -29.5t-72.5 29.5t-29.5 72.5zM1556 82q0 43 30 72.5t73 29.5t72.5 -29.5t29.5 -72.5 t-29.5 -72.5t-72.5 -29.5t-73 29.5t-30 72.5z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni202F",
    unicode: "\u202F",
    horizAdvX: 377
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglleft",
    unicode: "\u2039",
    horizAdvX: 563,
    d: "M82 444v136l389 286v-135l-258 -219l258 -219v-137z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "guilsinglright",
    unicode: "\u203A",
    horizAdvX: 563,
    d: "M92 156v135l258 219l-258 219v137l389 -288v-136z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni205F",
    unicode: "\u205F",
    horizAdvX: 471
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "Euro",
    unicode: "\u20AC",
    horizAdvX: 1161,
    d: "M41 426v135h125q-2 25 -2 78q0 51 2 78h-125v135h141q19 100 58.5 180t102 141t155 94t209.5 33q210 0 352 -61v-131q-90 33 -167.5 48t-184.5 15q-156 0 -247 -85.5t-126 -233.5h512l-47 -135h-486q-2 -27 -2 -78q0 -53 2 -78h432l-47 -135h-364q34 -148 125.5 -232.5 t247.5 -84.5q109 0 187 14.5t165 48.5v-131q-135 -61 -352 -61q-228 0 -357 119.5t-168 326.5h-141z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "trademark",
    unicode: "\u2122",
    horizAdvX: 1116,
    d: "M-2 1458v78h418v-78h-164v-434h-90v434h-164zM506 1024v512h112l158 -346l160 346h111v-512h-86l4 387l-150 -324h-78l-149 324l4 -387h-86z"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni25FC",
    unicode: "\u25FC",
    horizAdvX: 1024,
    d: "M0 0v1024h1024v-1024h-1024z"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "quoteleft,quotedblleft",
    k: 328
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "quoteright,quotedblright",
    k: 328
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "T",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "V",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "W",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "Y,Yacute,Ydieresis",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "v",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "w",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,ellipsis",
    g2: "y,yacute,ydieresis",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "comma,period,ellipsis",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "colon,semicolon",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE",
    k: 307
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "C,Ccedilla",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "OE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "S",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "ae",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,ccedilla",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "d,eth",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "g",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "oe",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "q",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,germandbls",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "W",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "space",
    g2: "Y,Yacute,Ydieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "T",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "V",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "W",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon",
    g2: "Y,Yacute,Ydieresis",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE",
    k: 307
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "C,Ccedilla",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "OE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "S",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quoteleft,quotedblleft",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "quoteright,quotedblright",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "T",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "V",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "W",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "Y,Yacute,Ydieresis",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "C,Ccedilla",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "OE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "S",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "v",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "y,yacute,ydieresis",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "c,ccedilla",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "d,eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,ellipsis",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "colon,semicolon",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "v",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "ae",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,ccedilla",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "d,eth",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "oe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,germandbls",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "quoteleft,quotedblleft",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "quoteright,quotedblright",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "T",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "V",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "W",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Y,Yacute,Ydieresis",
    k: 297
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "C,Ccedilla",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "G",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "OE",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "Q",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "v",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "w",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L",
    g2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "comma,period,ellipsis",
    k: 287
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "Y,Yacute,Ydieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "AE",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "v",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "ae",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "c,ccedilla",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "d,eth",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "oe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "s,germandbls",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "z",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "m",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "n,ntilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "p,thorn",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,Thorn",
    g2: "r",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "comma,period,ellipsis",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "colon,semicolon",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "AE",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "C,Ccedilla",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "G",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "J",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "OE",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "Q",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "v",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "w",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "y,yacute,ydieresis",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "ae",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "c,ccedilla",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "d,eth",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "g",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "oe",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "q",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "s,germandbls",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "space",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "j",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "f",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "i,igrave,iacute,icircumflex,idieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "t",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "x",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "z",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "m",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "n,ntilde",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "p,thorn",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T",
    g2: "r",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,ellipsis",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,Ccedilla",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "OE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "v",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y,yacute,ydieresis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "ae",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,ccedilla",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d,eth",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "g",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "oe",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "q",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,germandbls",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "space",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "x",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "n,ntilde",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "p,thorn",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "r",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "comma,period,ellipsis",
    k: 205
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "colon,semicolon",
    k: 154
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "AE",
    k: 184
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "ae",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "c,ccedilla",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "d,eth",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "g",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "oe",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "q",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "s,germandbls",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "space",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "t",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "z",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "m",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "n,ntilde",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "p,thorn",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W",
    g2: "r",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "comma,period,ellipsis",
    k: 246
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "colon,semicolon",
    k: 195
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 266
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "AE",
    k: 307
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "C,Ccedilla",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "G",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "J",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "OE",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "Q",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "S",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "v",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "w",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "y,yacute,ydieresis",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 287
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "ae",
    k: 287
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "c,ccedilla",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "d,eth",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "g",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "oe",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "q",
    k: 256
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "s,germandbls",
    k: 225
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "l",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "space",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "j",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "f",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "i,igrave,iacute,icircumflex,idieresis",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "t",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "x",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "z",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "m",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "n,ntilde",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "p,thorn",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ydieresis",
    g2: "r",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "W",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "Y,Yacute,Ydieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B",
    g2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "T",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "Y,Yacute,Ydieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla",
    g2: "AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "T",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "V",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "W",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "Y,Yacute,Ydieresis",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "AE",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth",
    g2: "X",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis",
    g2: "J",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,Egrave,Eacute,Ecircumflex,Edieresis",
    g2: "j",
    k: -31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "T",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "Y,Yacute,Ydieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G",
    g2: "AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "W",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "Y,Yacute,Ydieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "C,Ccedilla",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "G",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "OE",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "Q",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "S",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "v",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "w",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "y,yacute,ydieresis",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "ae",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "c,ccedilla",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "d,eth",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "oe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "s,germandbls",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "l",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "f",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "i,igrave,iacute,icircumflex,idieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "t",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K",
    g2: "z",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "T",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "Y,Yacute,Ydieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "AE",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    g2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q",
    g2: "T",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q",
    g2: "Y,Yacute,Ydieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q",
    g2: "AE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q",
    g2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "T",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "V",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R",
    g2: "Y,Yacute,Ydieresis",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "T",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "V",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "W",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "Y,Yacute,Ydieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "X",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S",
    g2: "Z",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "C,Ccedilla",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "G",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "OE",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "Q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "v",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "w",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "ae",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "c,ccedilla",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "d,eth",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "oe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "s,germandbls",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "z",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "m",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "n,ntilde",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "p,thorn",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X",
    g2: "r",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "v",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "w",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "y,yacute,ydieresis",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "f",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z",
    g2: "t",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "comma,period,ellipsis",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "ae",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "c,ccedilla",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "d,eth",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "oe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f",
    g2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "comma,period,ellipsis",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r",
    g2: "ae",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "comma,period,ellipsis",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "ae",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "c,ccedilla",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "d,eth",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "oe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v",
    g2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "comma,period,ellipsis",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "ae",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "c,ccedilla",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "d,eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "g",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w",
    g2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "comma,period,ellipsis",
    k: 164
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "c,ccedilla",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "d,eth",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "oe",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis",
    g2: "q",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "w",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "y,yacute,ydieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b",
    g2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,egrave,eacute,ecircumflex,edieresis",
    g2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,egrave,eacute,ecircumflex,edieresis",
    g2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,egrave,eacute,ecircumflex,edieresis",
    g2: "y,yacute,ydieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,egrave,eacute,ecircumflex,edieresis",
    g2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "ae",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "c,ccedilla",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "d,eth",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "oe",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "q",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "l",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "f",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "i,igrave,iacute,icircumflex,idieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "t",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    g2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    g2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    g2: "y,yacute,ydieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    g2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "p,thorn",
    g2: "v",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "p,thorn",
    g2: "w",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "p,thorn",
    g2: "y,yacute,ydieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "p,thorn",
    g2: "x",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "ae",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "c,ccedilla",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "d,eth",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "g",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "oe",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "q",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "l",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "f",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "i,igrave,iacute,icircumflex,idieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "t",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x",
    g2: "u,ugrave,uacute,ucircumflex,udieresis",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "ae",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "c,ccedilla",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "d,eth",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "e,egrave,eacute,ecircumflex,edieresis",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "oe",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z",
    g2: "q",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "four",
    k: 123
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApexNewWebBookRegular);
export default __webpack_public_path__ + "static/media/ApexNewWeb-Book-Regular.d0a952adad9f06d95965653b60a6d81b.svg";
export { ForwardRef as ReactComponent };